export const frMessages = {
  rma: {
    ProductReturnsTitle: 'Retours de Produits',
    AllProductReturns: 'Tous les retours de produits',
    KeepTrackDescription: 'Suivez tous vos retours de produits',
    NewProductReturn: 'Nouveau Retour de Produit',
    SearchByNameOrReference: 'Rechercher par nom ou numéro de référence...',
    Filters: 'Filtres',
    ReturnsWithNoTracking: 'Retours sans numéro de suivi',
    From: 'De',
    ComplaintsTitle: 'Réclamations',
    ReviewAndManage: 'Examiner et gérer les réclamations des clients',
    RecordComplaint: 'Enregistrer une réclamation',
    Status: 'Statut',
    SelectStatus: 'Sélectionner un statut',
    MaxResults: 'Résultats max.',
    SelectColumn: 'Colonne',
    SelectOperator: 'Opérateur',
    SearchFor: 'Rechercher',
    SearchPlaceholder: 'Saisir le texte de recherche...',
    Search: 'Rechercher',
    Filter: 'Filtrer',
    FilterTitle: 'Filtrer les réclamations',
    ApplyFilters: 'Appliquer les filtres',
    ClearFilters: 'Effacer les filtres',
    CloseFilters: 'Fermer',
    NoComplaintsFound: 'Aucune réclamation trouvée pour les critères sélectionnés.',
    LastName: 'Nom',
    FirstName: 'Prénom',
    Name: 'Nom',
    RMANumber: 'Numéro RMA',
    RMADetails: 'Détails RMA',
    DateOfSubmission: 'Date de soumission',
    CreatedDate: 'Date de création',
    FeeTotal: 'Total des frais',
    Total: 'Total',
    TrackingNumber: 'Numéro de suivi',
    NoTrackingProvided: 'Aucun numéro de suivi fourni',
    Showing: 'Affichage de',
    To: 'à',
    Of: 'sur',
    Entries: 'entrées',
    Previous: 'Précédent',
    Next: 'Suivant',
    FirstPage: 'Première page',
    PreviousPage: 'Page précédente',
    NextPage: 'Page suivante',
    LastPage: 'Dernière page',
    Close: 'Fermer',
    ReturnStatus: 'État du retour',
    CustomerInformation: 'Informations client',
    ComplaintDetails: 'Détails de la réclamation',
    ProductInformation: 'Informations produit',
    RefundInformation: 'Informations de remboursement',
    RefundAmount: 'Montant du remboursement',
    ShippingAmount: 'Montant de l\'expédition',
    ShippingMethod: 'Mode d\'expédition',
    AOEOrderId: 'ID de commande AOE',
    ClosedDate: 'Date de clôture',
    IsSubmitted: 'Est soumis',
    ExportDate: 'Date d\'exportation',
    Notes: 'Notes',
    Yes: 'Oui',
    NotAvailable: 'Non disponible',
    All: 'Tous',
    Open: 'Ouvert',
    WillBeShipped: 'Sera expédié',
    Closed: 'Fermé',
    Cancelled: 'Annulé',
    OnHold: 'En attente',
    ReturnExpected: 'Retour attendu',
    CreditDebitProcessingError: 'Erreur de traitement de paiement',
    ClosedWithoutReturns: 'Fermé sans retours',
    New: 'Nouveau',
    ManualReimbursementRequired: 'Remboursement manuel requis',
    PhotoIsMissing: 'Photo manquante',
    ReceiptInProcess: 'Reçu en cours de traitement',
    ReleaseAwaited: 'Libération attendue',
    StartsWith: 'Commence par',
    EndsWith: 'Se termine par',
    Contains: 'Contient',
    Equals: 'Est égal à',
    Between: 'Entre',
    GreaterThan: 'Supérieur à',
    LessThan: 'Inférieur à',
    ItemsBeingReturned: 'Articles retournés',
    ReplacementItems: 'Articles de remplacement',
    Exit: 'Quitter',
    SubmitSuccess: 'Succès!',
    RMASubmittedSuccessfully: 'RMA {rmaNumber} soumise avec succès!',
    ReturnAddress: 'Adresse de retour',
    NoAddressSelected: 'Aucune adresse sélectionnée',
    SelectAddress: 'Sélectionner une adresse',
    SelectReturnAddress: 'Sélectionner l\'adresse de retour',
    AddNewAddress: 'Ajouter une nouvelle adresse',
    SubmitRMA: 'Soumettre le RMA',
    GoBack: 'Retour',
    AddressSaved: 'Adresse enregistrée',
    AddressSaveError: 'Échec de l\'enregistrement de l\'adresse',
    RequiredAddressFields: 'Veuillez remplir tous les champs d\'adresse requis',
    SelectReasonPlaceholder: 'Sélectionner un motif...',
    returnReasons: {
      DUR: 'Casse lors de l\'utilisation - DUR',
      DSR: 'Casse à la livraison - DSR',
      EXR: 'Retour échange - EXR',
    },
    errors: {
      enterOrderNumber: 'Veuillez saisir un numéro de commande',
      enterValidOrderNumber: 'Veuillez saisir un numéro de commande valide',
      failedToLoadOrderDetails: 'Impossible de charger les détails de la commande. Veuillez réessayer.',
      orderNotFound: 'Commande introuvable. Veuillez vérifier le numéro de commande et réessayer.',
      failedToSearchOrder: 'La recherche de la commande a échoué. Veuillez réessayer.',
      orderDetailsNotFound: 'Détails de commande introuvables',
      rmaNotCreated: 'Le RMA n\'a pas été créé. Veuillez revenir en arrière et réessayer.',
      failedToSubmitRMA: 'Impossible de soumettre le RMA. Veuillez réessayer.',
      failedToUpdateRefund: 'Impossible de mettre à jour la sélection du remboursement. Veuillez réessayer.',
      failedToLoadPaymentMethods: 'Impossible de charger les méthodes de paiement disponibles. Veuillez réessayer.',
      selectAtLeastOneItemToReturn: 'Veuillez sélectionner au moins un article ou un composant à retourner',
      selectReasonForAllSelectedItems: 'Veuillez sélectionner un motif pour tous les articles sélectionnés',
      selectReasonForAllSelectedComponents: 'Veuillez sélectionner un motif pour tous les composants sélectionnés',
      failedToCreateRMA: 'Impossible de créer le RMA. Veuillez réessayer.',
    },
    // Order details grid
    Details: 'Détails',
    Warehouse: 'Entrepôt',
    LastUpdated: 'Dernière mise à jour',
    OrderTotal: 'Total de la commande',
    OrderType: 'Type de commande',
    Orders: 'Commandes',
    OrderNumber: 'Numéro de commande',
    OrderDate: 'Date de commande',
    ComplaintSubmitted: 'Réclamation soumise',
    Guests: 'Invités',
    Customer: 'Client',
    CustomerStatus: 'Statut du client',
    DeliveryAddress: 'Adresse de livraison',
    EmailAddress: 'Adresse e-mail',
    PhoneNumber: 'Numéro de téléphone',
    Consultant: 'Consultant',
    Advisor: 'Conseiller',
    GoodStanding: 'En règle',
    FinancialState: 'État financier',
    // Reason codes
    ReasonCodesTitle: 'Codes de motif de retour',
    ReasonCodeDUR: 'DUR - Casse lors de l\'utilisation',
    ReasonCodeDURDescription: 'Le produit est défectueux lors de l\'utilisation.',
    ReasonCodeDSR: 'DSR - Casse à la livraison',
    ReasonCodeDSRDescription: 'Le produit est arrivé endommagé.',
    ReasonCodePQ: 'PQR - Qualité du produit',
    ReasonCodePQDescription: 'Le produit a été livré avec un défaut ou une anomalie.',
    ReasonCodeEX: 'EXR - Échange',
    ReasonCodeEXDescription: 'Échange pour un article différent.',
    ReasonCodesNote: 'Jamais Les échanges d\'articles de plus de 30 jours ne sont pas acceptés. Une fois que vous avez soumis avec succès votre réclamation, une étiquette de retour sera créée par l\'équipe du service client dans les 48 à 72 heures. Vous recevrez un e-mail séparé contenant votre étiquette de retour.',
    // Exchange item selection
    SelectExchangeItem: 'Sélectionner l\'article d\'échange',
    SearchForProduct: 'Rechercher un produit (min 3 caractères)...',
    ExchangeItemSelected: 'Article d\'échange sélectionné',
    RemoveExchangeItem: 'Supprimer et sélectionner un autre article',
    ExchangeItemRequired: 'Article d\'\u00e9change requis',
    ExchangeItemRequiredMessage: 'Veuillez sélectionner un article d\'\u00e9change pour tous les articles marqués pour l\'\u00e9change',
    UploadPhotos: 'Télécharger des photos et vidéos',
    UploadPhotosTitle: 'Télécharger des photos et vidéos de l\'article retourné',
    UploadNewPhotos: 'Télécharger de nouvelles photos et vidéos',
    PreviouslyUploadedPhotos: 'Photos et vidéos précédemment téléchargées',
    PhotoRequired: 'Requis',
    PhotoRequiredMessage: 'Veuillez télécharger des photos ou vidéos pour tous les articles qui en nécessitent. Recherchez les articles marqués d\'un astérisque rouge (*).',
    SKUComponents: 'Composants SKU',
    InitiateReturn: 'Initier un retour',
    EnterOrderNumber: 'Entrez votre numéro de commande ci-dessous pour commencer le processus de retour.',
    OrderNumberPlaceholder: 'Entrez le numéro de commande...',
    Searching: 'Recherche en cours...',
    ExistingRMAFound: 'RMA existante trouvée',
    ExistingRMAMessage: 'Une RMA existante a déjà été soumise pour cette commande.',
    ExistingRMAInfo: 'Veuillez contacter le service client si vous avez besoin d\'aide pour ce retour.',
    SelectItemsToReturn: 'Sélectionner les articles à retourner',
    SelectItemsInstruction: 'Sélectionnez les articles que vous souhaitez retourner et indiquez un motif pour chacun.',
    SKU: 'SKU',
    ProductCode: 'Code produit',
    Quantity: 'Quantité',
    LineTotal: 'Total de la ligne',
    ReturnReason: 'Motif de retour',
    ItemsSelected: 'article(s) sélectionné(s)',
    ProceedWithReturn: 'Procéder au retour',
    ItemsToReceive: 'Articles à recevoir',
    Totals: 'Totaux',
    CreditAmount: 'Montant du crédit',
    Fees: 'Frais',
    ReturnCreditBalance: 'Solde de crédit du retour',
    NewPurchases: 'Nouveaux achats',
    BuyingDiscount: 'Remise d\'achat',
    RefundMethod: 'Méthode de remboursement',
    ReturnCreditRequired: 'Un crédit vous est dû pour ce retour. Sélectionnez comment vous souhaitez être remboursé.',
    RefundOriginalPaymentMethod: 'Rembourser sur le mode de paiement d\'origine',
    RefundColumnName: 'Paiement',
    RefundColumnCharge: 'Montant initial',
    RefundColumnChargeNotRefunded: 'Disponible pour remboursement',
    RefundColumnRefundAmount: 'Montant du remboursement',
    RefundRemainingToAllocate: '{amount} doit encore être attribué à une méthode de remboursement avant de pouvoir soumettre ce retour.',
    PaymentRequired: 'Paiement requis',
    PaymentRequiredDescription: 'Un paiement supplémentaire est requis pour finaliser ce retour. Veuillez fournir un mode de paiement ci-dessous.',
    BrainTreeCreditCardHeader: 'Carte de crédit',
    BrainTreePaymentAmount: 'Montant du paiement',
    BrainTreeAddPayment: 'Ajouter le paiement',
    BankPaymentHeader: 'Payer avec un compte bancaire',
    BankPaymentInstruction: 'Effectuez un paiement en utilisant votre compte bancaire pour couvrir le solde dû sur ce retour.',
    BankPaymentYourBankDetails: 'Vos coordonnées bancaires',
    BankPaymentAccountHolder: 'Titulaire du compte',
    BankPaymentAccountNumber: 'Numéro de compte',
    BankPaymentRoutingNumber: 'Code bancaire',
    BankPaymentAmount: 'Montant du paiement',
    BankPaymentPayWithBank: 'Payer avec un compte bancaire',
    BankPaymentProcessing: 'Traitement en cours...',
    BankPaymentNoBankDetailsFound: 'Aucune coordonnée bancaire trouvée. Veuillez ajouter vos coordonnées bancaires pour utiliser ce mode de paiement.',
  },
  validators: {
    requiredField: '{fieldName} est requis',
    birthDateRequired: 'Date de naissance requise',
    emailRequired: 'L\u2019adresse e-mail est obligatoire',
    phoneRequired: 'Le numéro de téléphone est obligatoire',
    passwordRequired: 'Mot de passe requis',
    confirmPasswordRequired: 'Confirmation du mot de passe requise',
    passwordMismatch: 'Les mots de passe ne correspondent pas',
    emailField: '{fieldName} est une adresse e-mail invalide',
    nameField: '{fieldName} ne peut contenir que des lettres, des espaces, des tirets et des apostrophes',
    fieldLength: '{fieldName} doit comporter au maximum {maximumLength} caractères.',
    fieldMinLength: '{fieldName} doit comporter au moins {minimumLength} caractères.',
    nameMinLength: '{fieldName} doit comporter au moins {minimumLength} caractères.',
    nameMaxLength: '{fieldName} ne peut pas dépasser {maximumLength} caractères.',
    streetField: '{fieldName} ne peut contenir que des lettres, des espaces, des tirets et des apostrophes (pas de chiffres ni de symboles)',
    houseNumberField: '{fieldName} doit commencer par un chiffre et peut contenir un suffixe de lettre facultatif (ex. 12A)',
    cityField: '{fieldName} ne peut contenir que des lettres, des espaces, des tirets et des apostrophes',
    houseNumberFormat: '{fieldName} doit commencer par un chiffre (ex. 12, 12A, 12/3 ou 12-14)',
    nameAddressField: '{fieldName} ne peut contenir que des lettres, des espaces, des tirets et des apostrophes',
    nameAddressMinLength: '{fieldName} doit comporter au moins {minimumLength} caractères',
    nameAddressMaxLength: '{fieldName} ne peut pas dépasser {maximumLength} caractères',
    formatField: '{fieldName} a un format invalide.',
    phoneNumericOnly: '{fieldName} ne doit contenir que des chiffres (sans espaces ni symboles)',
    phoneLengthInvalid: '{fieldName} doit contenir {min}-{max} chiffres',
    postalCodeLength: '{fieldName} doit contenir {requiredLength} chiffres pour le pays sélectionné',
    passwordPattern: '<div>Le mot de passe doit répondre aux exigences minimales:<br/><ul><li>Une lettre minuscule</li><li>Une lettre majuscule</li><li>Un chiffre</li><li>Au moins un caractère spécial (!#$%&#92;-_=+&#64;)</li><li>Au moins 8 caractères</li></ul></div>',
    minimumAge: 'Vous devez avoir au moins 18 ans pour continuer.',
    businessNameRequired: 'Vous devez mettre à jour le nom de votre entreprise pour continuer',
    directDepositRequired: 'Le dépôt direct est requis',
    authorizedToWorkRequired: 'Vous devez confirmer que vous êtes autorisé à travailler en France',
    siretWarning: 'Pampered Chef ne pourra pas verser de commissions tant qu\'un numéro SIRET n\'aura pas été fourni.',
    contractAgreementRequired: 'Vous devez accepter les pratiques commerciales et le code d\'éthique pour continuer',
    vatNumberFormat: 'Le numéro de TVA français doit commencer par FR suivi de 11 caractères (ex: FR12345678901)',
    vatNumberFormatATDE: 'Le numéro de TVA doit être au format allemand (DE + 9 chiffres) ou au format autrichien (ATU + 8 chiffres)',
    ibanFormat: 'Le format IBAN est invalide. Veuillez vérifier le code pays et la longueur.',
    ibanFormatFR: 'L\'IBAN français doit comporter 27 caractères (FR + 25 chiffres)',
    ibanFormatDE: 'L\'IBAN allemand doit comporter 22 caractères (DE + 20 chiffres)',
    ibanFormatAT: 'L\'IBAN autrichien doit comporter 20 caractères (AT + 18 chiffres)',
    bicFormat: 'Le BIC doit comporter 8 ou 11 caractères avec un code pays valide',
    consultantEmailNotAllowed: 'Cette adresse e-mail est déjà associée à un compte de consultant et ne peut pas être utilisée pour le paiement du kit.',
  },
  errors: {
    loadingCountryCode: 'Erreur lors du chargement des informations du pays. Veuillez réessayer.',
    savingBankDetails: 'Erreur lors de l\'enregistrement des coordonnées bancaires. Veuillez réessayer.',
    updatingBusinessName: 'Erreur lors de la mise à jour du nom de l\'entreprise. Veuillez réessayer.',
    businessNameAlreadyExists: 'Le nom de l\'entreprise existe déjà. Veuillez en choisir un autre.',
    savingFrenchContribution: 'Erreur lors de l\'enregistrement des informations de contribution française. Veuillez réessayer.',
    loadingFrenchContribution: 'Erreur lors du chargement des informations de contribution française. Veuillez réessayer.',
    governmentIdInvalid: 'Le numéro SSN ou SIRET fourni est invalide. Veuillez vérifier et corriger vos informations.',
    loadingContractTerms: 'Erreur lors du chargement des conditions du contrat. Veuillez réessayer.',
    savingContractAgreement: 'Erreur lors de l\'enregistrement de l\'accord contractuel. Veuillez réessayer.',
    savingVatInformation: 'Erreur lors de l\'enregistrement des informations de TVA. Veuillez réessayer.',
    loadingVatInformation: 'Erreur lors du chargement des informations de TVA. Veuillez réessayer.',
    wizardCompletionFailed: 'Erreur lors de l\'enregistrement de l\'achèvement de l\'assistant. Votre compte a été configuré, mais il y a eu un problème avec l\'étape finale.',
    wizardCompletionRetry: 'Nous n\'avons pas pu finaliser la configuration de votre compte. Veuillez réessayer pour terminer cette dernière étape.',
    userNotAuthenticatedOrInvalidBeeNumber: 'Utilisateur non authentifié ou numéro BEE invalide',
    userNotAuthenticatedOrInvalidBusinessGuid: 'Utilisateur non authentifié ou GUID d\'entreprise invalide',
    failedToSaveBankDetails: 'Échec de l\'enregistrement des coordonnées bancaires',
    failedToSaveFrenchContributionData: 'Échec de l\'enregistrement des données de contribution française',
    unableToGetAuthenticatedUserBeeNumber: 'Impossible d\'obtenir le numéro BEE de l\'utilisateur authentifié',
    noShippingAddressFoundInAddressBookEntry: 'Aucune adresse de livraison trouvée dans l\'entrée du carnet d\'adresses',
    noAddressBookEntryFoundForHostEmail: 'Aucune entrée de carnet d\'adresses trouvée pour l\'e-mail de l\'hôte',
    unableToGetBeeNumber: 'Impossible d\'obtenir le numéro BEE',
    noReportIdSpecified: 'Aucun ID de rapport spécifié',
    noConsultantDataReceived: 'Aucune donnée de consultant reçue',
    invoiceIsCanceled: 'La facture est annulée',
    missingBeeNumberToken: 'Le jeton de vérification de l’adresse e-mail est manquant.',
  },
  messages: {
    bankDetailsSaved: 'Vos coordonnées bancaires ont été enregistrées avec succès.',
    wizardCompleted: 'Configuration du compte terminée avec succès!',
    businessNameUpdated: 'Le nom de votre entreprise a été mis à jour avec succès.',
    frenchContributionSaved: 'Vos informations de contribution française ont été enregistrées avec succès.',
    contractAgreementSaved: 'Votre accord contractuel a été enregistré avec succès.',
    vatInformationSaved: 'Vos informations de TVA ont été enregistrées avec succès.',
    emailAddressVerified: 'Merci d’avoir vérifié votre adresse e-mail.',
  },
  actions: {
    TryAgain: 'Réessayer',
    Save: 'Enregistrer',
    UpdateBusinessName: 'Mettre à jour le nom de l\'entreprise',
    AcceptAndContinue: 'Accepter et continuer',
  },
  security_question_1: 'Quel était votre surnom d\'enfance?',
  security_question_2: 'Dans quelle ville ou village avez-vous rencontré votre conjoint/partenaire?',
  security_question_3: 'Quel est le nom de votre meilleur ami d\'enfance?',
  security_question_4: 'Dans quelle rue habitiez-vous en troisième année?',
  security_question_5: 'Quel est le mois et l\'année de naissance de votre frère ou sœur aîné(e)? (ex: Janvier 1970)',
  security_question_6: 'Quel est le deuxième prénom de votre plus jeune enfant?',
  security_question_7: 'Quel est le deuxième prénom de votre frère ou sœur aîné(e)?',
  security_question_8: 'Quelle école avez-vous fréquentée en sixième année?',
  security_question_9: 'Quel était le nom de votre premier animal en peluche?',
  security_question_10: 'Dans quelle ville ou village se sont rencontrés votre mère et votre père?',

  routes: {
    CountryList: 'Liste des pays',
    CountryEdit: 'Modifier le pays',
    DocumentTemplateList: 'Liste des modèles de documents',
    DocumentTemplateEdit: 'Modifier le modèle de document',
    DocumentTemplateCultureSpecificList: 'Liste des modèles de documents spécifiques à la culture',
    DocumentTemplateCultureSpecificEdit: 'Modifier le modèle de document spécifique à la culture',
    Home: 'Accueil',
    Logout: 'Déconnexion',
    LocaleChanger: 'Changeur de langue',
    Setup: 'Configuration',
    StateList: 'Liste des états',
    StateEdit: 'Modifier l\'état',
    Welcome: 'Bienvenue',
    Checkout22: 'Caisse 21',
  },
  buttons: {
    Edit: 'Modifier',
    Delete: 'Supprimer',
    Yes: 'Oui',
    No: 'Non',
    Add: 'Ajouter',
    Filter: 'Filtrer',
    Clear: 'Effacer',
    Apply: 'Appliquer',
    Save: 'Enregistrer',
    Exit: 'Quitter',
    StateList: 'Liste des états',
    DocumentTemplateCultureSpecificList: 'Liste des modèles de documents spécifiques à la culture',
    Html: 'Html',
    Raw: 'Brut',
    CareerPlan: 'Plan de Carrière',
    MyParties: 'Mes Fêtes',
    TrainingVideos: 'Vidéos de Formation',
    MyTeam: 'Aperçu de l\'Équipe',
    UseCoupon: 'Utiliser un coupon',
    ApplyCoupon: 'Appliquer le coupon',
    RemoveCoupon: 'Retirer le coupon ({0})',
    Okay: 'D\'accord',
    Back: 'Retour',
    Cancel: 'Annuler',
    Close: 'Fermer',
    Submit: 'Soumettre',
  },
  accessibility: {
    required: 'obligatoire',
  },
  labels: {
    Dash: '-',
    Actions: 'Actions',
    AddToCart: 'AJOUTER AU PANIER',
    BecomeAConsultant: 'Intéressé à devenir consultant',
    Cancel: 'Annuler',
    Confirm: 'Confirmer',
    ContractAgreementHeader: 'Accord de contrat de consultant',
    ContractAgreementSubHeader: 'Veuillez examiner les pratiques commerciales et le code d\'éthique ci-dessous avant de continuer',
    LoadingContractTerms: 'Chargement des conditions du contrat...',
    NoContractTerms: 'Aucune condition contractuelle disponible',
    Success: 'Succès',
    Saving: 'Enregistrement...',
    CheckingInventory: 'Vérification du stock...',
    InStock: 'En stock',
    SelectOption: 'Sélectionnez une option',
    SelectValue: 'Sélectionnez une valeur',
    PricePerUnitWeight: {
      Weight: '{0} g',
      PricePerUnit: '({0}/kg)',
    },
    MonthToDate: 'Mois à ce jour',
    YearToDate: 'Année à ce jour',
    CustomRange: 'Plage personnalisée',
    BusinessInfoHeader: 'Informations sur l\'entreprise',
    BusinessInfoSubHeader: 'Veuillez fournir les informations de votre entreprise pour compléter votre inscription',
    BusinessName: 'Nom de l\'entreprise',
    FrenchContributionHeader: 'Informations de contribution française',
    FrenchContributionSubHeader: 'Veuillez fournir les informations requises pour la juridiction française',
    EmployeeStatus: 'Statut d\'employé',
    SSN: 'Numéro de sécurité sociale',
    SSNPlaceholder: 'Entrez votre numéro de sécurité sociale à 15 chiffres',
    SIRET: 'Numéro SIRET',
    SIRETPlaceholder: 'Entrez votre numéro SIRET',
    BirthCity: 'Ville de naissance',
    BirthCityPlaceholder: 'Entrez votre ville de naissance',
    BirthCountry: 'Pays de naissance',
    FrenchCitizen: 'Je suis citoyen français',
    AuthorizedToWork: 'Je suis autorisé à travailler en France',
    LoadingFrenchContribution: 'Chargement des informations de contribution française...',
    VatType: 'Type de TVA',
    VatNumber: 'Numéro de TVA',
    VatNumberPlaceholder: 'Entrez votre numéro de TVA (ex: FR12345678901)',
    VatNumberPlaceholderATDE: 'Entrez votre numéro de TVA (ex: DE123456789 ou ATU12345678)',
    TaxIdNoInputRequired: 'Aucune saisie requise pour TAXID',
    LoadingVatInformation: 'Chargement des informations TVA...',
    Updating: 'Mise à jour...',
    BusinessNamePlaceholder: 'Entrez le nom de votre entreprise',
    PersonalURL: 'URL de votre site web personnel',
    NewUserWizardHeader: 'Bienvenue dans la configuration de votre compte',
    NewUserWizardSubHeader: 'Veuillez suivre les étapes suivantes pour configurer votre compte',
    BankDetailsHeader: 'Informations Bancaires',
    BankDetailsSubHeader: 'Veuillez saisir vos coordonnées bancaires pour recevoir les paiements de commission',
    BankAccountType: 'Type de Compte Bancaire',
    BankName: 'Nom de la Banque',
    BankNamePlaceholder: 'Entrez le nom de votre banque',
    BIC: 'BIC (Code d\'Identification Bancaire)',
    BICPlaceholder: 'Entrez votre code BIC',
    IBAN: 'IBAN',
    IBANPlaceholder: 'Entrez votre IBAN',
    DirectDeposit: 'J\'autorise le dépôt direct pour les paiements de commission',
    OPA: 'OPA (Optionnel)',
    LoadingBankDetails: 'Chargement des informations bancaires...',
    ExitImageOverlay: 'Cliquez sur l\'image pour réduire',
    Filter: 'Filtrer',
    GridNoRecords: 'Aucun enregistrement trouvé',
    Search: 'Rechercher',
    Language: 'Langue',
    ChooseLanguage: 'Sélectionner la langue',
    ChooseCountry: "Sélectionnez votre pays",
    SearchKeyword: 'Rechercher par mot-clé',
    ShowMore: 'Afficher plus de résultats',
    ShowLess: 'Afficher moins',
    NoResultsFound: 'Aucun résultat trouvé',
    View: 'Voir',
    Logout: 'Déconnexion',
    Okay: 'D\'accord',
    Error: 'Erreur',
    Loading: 'Chargement',
    SkuPrefix: 'SKU : {sku}',
    DropDownListPlaceholder: 'Sélectionnez un {value}',
    CardHolderName: 'Nom du titulaire de la carte',
    CardNumber: 'Numéro de carte',
    CardExpirationDate: 'Date d\'expiration',
    CardSecurityCode: 'CVV',
    EmailMoreInfoCheckbox: 'Je souhaite recevoir des e-mails sur les produits, recettes, offres spéciales et ventes.',
    CheckoutContinue: 'Continuer',
    CheckoutPlaceOrder: 'Passer la commande',
    NewCheckoutPlaceOrder: 'COMMANDER ET PAYER',
    CheckoutUseSelectedAddress: 'Utiliser l\'adresse sélectionnée',
    CheckoutReEnterAddress: 'Saisir à nouveau l\'adresse',
    SameAsBillingCheckbox: 'Utiliser cette adresse comme informations de facturation',
    FreeProductQuantityPrefix: '{quantity}x ',
    MarketingOptIn_NEWSLETTER_Content: '<span class="marketingconent"><p>J\'aimerais être informé à l\'avenir des tendances, des bonnes affaires, des bons, des promotions et des offres de Pampered Chef France par e-mail.</p><br> <p>Vous pouvez révoquer votre consentement à ces activités à tout moment et gratuitement. Vous trouverez de plus amples informations sur la manière dont nous traitons vos données à caractère personnel et sur la manière dont vous pouvez révoquer votre consentement dans notre politique de confidentialité</p></span>',
    MarketingOptIn_MARKETING_Content:  '<span class="marketingconent"><p>J\'aimerais être informé à l\'avenir des tendances, des bonnes affaires, des bons, des promotions et des offres de Pampered Chef France par e-mail.</p><br> <p>Vous pouvez révoquer votre consentement à ces activités à tout moment et gratuitement. Vous trouverez de plus amples informations sur la manière dont nous traitons vos données à caractère personnel et sur la manière dont vous pouvez révoquer votre consentement dans notre politique de confidentialité</p></span>',
    Country: 'Pays',
    BirthDate: 'Date de naissance',
    RegistrationHeader: 'Créer un compte',
    CreateAccount: 'Créer un compte',
    MarketingOptIn: 'Traitement des données à des fins publicitaires',
  },
  address: {
    AddressLines: 'Adresse',
    City: 'Ville',
    Country: 'Pays',
    Name: 'Prénom et nom',
    NameRequired: 'Veuillez remplir les champs marqués d\'un *.',
    PostalCode: 'Code Postal',
    State: 'État/Province',
    Street2: 'Ligne d\'adresse 2',
    HouseNumber: 'Numéro de maison',
    Street: 'Rue',
  },

  cart: {
    CartHeader: 'Votre Panier',
    Select: 'Sélectionner',
    Checkout: 'Caisse',
    ApplePayCheckout: 'Payer avec',
    ApplePayImageAlt: 'Apple Pay',
    CompleteSet: 'Complétez votre ensemble',
    ConnectHeader: 'Connectez-vous à un consultant',
    ConnectSubHeader: 'Vous n\'avez pas encore trouvé le conseiller qui vous convient ? Nous vous aidons à en trouver un près de chez vous.',
    ConsultantByName: 'Par nom',
    ConsultantByLocation: 'Par localisation',
    ConsultantListHeader: 'Consultants près de chez vous',
    ContinueShopping: 'CONTINUER VOS ACHATS',
    FindConsultatHeader: 'Trouver un consultant',
    FindConsultatSubHeader: 'Entrez le prénom et le nom de votre consultant, ou recherchez un consultant près de chez vous.',
    FindParty: 'TROUVER UNE FÊTE',
    FindPartyHeader: 'Trouver une fête',
    FindPartyConsultant: 'TROUVER UN CONSULTANT',
    FindPartySubHeader: 'Recherche ciblée par numéro d\'\u00e9mission culinaire ou nom de l\'animateur.',
    GuestCheckout: 'Caisse en tant qu\'invité',
    GuestCheckoutSubHeader: 'Vous pouvez passer à la caisse en tant qu\'invité et créer un compte plus tard.',
    HostedBy: 'Organisé par',
    InterestedInHosting: 'Intéressé par l\'organisation d\'une fête ?',
    InterestedInHostingLink: 'En savoir plus',
    NoFreeGift: 'Non merci, je ne veux pas de cadeau gratuit',
    NotOrderWithConsultant: 'Je ne commande pas avec un consultant',
    NotSupported: 'Non pris en charge',
    OrderingWith: 'Vous commandez avec',
    OrderSummary: 'Résumé de la commande',
    PlaceHolderConsultantName: 'Entrez le nom du consultant',
    PlaceHolderHost: 'Recherche ciblée par numéro d\'\u00e9mission culinaire ou nom de l\'animateur.',
    PlaceholderZipcode: 'Entrez un code postal',
    RelatedProducts: 'Produits que vous pourriez aimer',
    RemoveParty: 'Supprimer la fête',
    RemoveConsultant: 'Supprimer le consultant',
    SelectButton: 'Sélectionner',
    SelectedFreeGift: 'Sélectionné',
    Shipping: 'Expédition',
    SignIn: 'Se connecter',
    SignInSubHeader: 'Veuillez vous connecter pour un passage à la caisse plus rapide et pour appliquer vos réductions et/ou crédits.',
    Subtotal: 'Sous-total',
    SystemKeyword: 'Mot-clé système',
    TaxCalc: 'Taxes calculées à la caisse',
    Total: 'Total TTC',
    ProductTotal: 'Total des produits',
    DiscountTotal: 'Remise',
    UnderParty: 'Sous',
    ViewCart: 'Voir le panier',
    WhereParty: 'Où',
    MustSelectPartyOrConsultant: 'Vous devez sélectionner une fête ou un consultant pour continuer.',
    MustSelectFreeProductOrOptOut: 'Veuillez sélectionner votre produit gratuit ou refuser avant de continuer.',
    ShowFreeGift: 'Afficher les cadeaux gratuits',
    EmptyCart: 'Votre panier est vide',
    EmptyCartMessage: 'Tes articles apparaissent ici dès qu\'ils sont ajoutés au panier.',
    CloseCart: 'Fermer le panier',
    ProductImageAlt: 'Image du produit',
    ConsultantPhotoAlt: 'Photo du consultant',
    RemoveFromCart: 'Retirer du panier',
    ItemRemovedFromCart: "'{skuName}' a été retiré de votre panier.",
    warnings: {
      RESTRICTED_ITEM_SHIPPING: "Le SKU '{skuCode}' n'est pas disponible pour le mode de livraison sélectionné",
      RESTRICTED_ITEM: 'Certains articles de votre panier ont des restrictions.',
      INVALID_SHIPPING_METHOD: 'Le mode de livraison sélectionné n\'est pas disponible pour votre adresse.',
      MINIMUM_ORDER_NOT_MET: 'Votre commande ne respecte pas le montant minimum requis.',
      SkuShippingRestriction: "Le SKU '{SkuCode}' n'est pas disponible pour le mode de livraison sélectionné",
    },
  },
  checkout: {
    AddressRequirementMessage: 'Veuillez remplir les champs marqués d\'un *.',
    BillingAddressHeader: 'Adresse de facturation',
    Checkout: 'Caisse',
    KitCheckout: 'Finaliser l\'inscription',
    CheckoutAddressValAddressEntered: 'Adresse saisie :',
    CheckoutAddressValHdr: 'Nous n\'avons pas pu vérifier l\'adresse que vous avez saisie.',
    CheckoutAddressValSubHdr: 'Veuillez sélectionner une adresse dans la liste ci-dessous ou modifier votre adresse.',
    CheckoutAddressValVerifiedAddress: 'Options d\'adresse vérifiées :',
    CheckoutAddressValWarning: 'Vous devez sélectionner une adresse vérifiée pour continuer.',
    CheckoutAddressValError: 'L\'adresse n\'a pas pu être vérifiée. Veuillez ressaisir votre adresse ou continuer avec l\'adresse saisie.',
    CheckoutEditStep: 'Modifier',
    CheckoutPaymentHdrStep: '3. Paiement',
    CheckoutOrderSummaryHdr: 'Résumé de la commande',
    CheckoutShipping: 'Expédition',
    CheckoutShippingHdrStep: '2. Expédition',
    CheckoutSubHeader: 'Connectez-vous pour un passage à la caisse plus rapide et pour appliquer vos réductions et/ou crédits.',
    CheckoutSubHeaderRemainder: 'pour un passage à la caisse plus rapide et pour appliquer vos réductions et/ou crédits.',
    CheckoutSubtotal: 'Sous-total',
    CheckoutTax: 'Impôts',
    CheckoutTotal: 'Total TTC',
    CheckoutTotalRegularPrice: 'Prix total régulier',
    PaymentAmount: 'Montant du paiement',
    CheckoutYourInformationHdrStep: '1. Vos informations',
    CreditCartHeader: 'Informations sur la carte de crédit',
    CreditCartSubmit: 'Soumettre',
    OrderSummaryYourOrder: 'Votre commande',
    OrderSummaryItem: 'Articles',
    NotSuppoted: 'n\'est pas pris en charge',
    OrderNumber: 'Numéro de commande',
    Quantity: 'Quantité',
    paymentMethods: {
      TTGBraintree: 'Carte de crédit',
      TTGBraintreeAPM: 'EPS',
      TTGBraintreeFR: 'Carte de crédit',
      TTGBraintreeAT: 'Carte de crédit',
      TTGBraintreeDE: 'Carte de crédit',
      OPA: 'OPA',
      PayPal: 'PayPal',
      EPS: 'EPS',
    },
    transactionStates: {
      NotProcessed: 'Autorisé',
      PreAuthorized: 'Pré-autorisé',
      Authorized: 'Autorisé',
      Booked: 'Réservé',
      Refunded: 'Remboursé',
      Processed: 'Traité',
    },
  },
  eventList: {
    AddHost: 'Ajouter l\'hôte',
    AtHostAddress: 'À l\'adresse de l\'hôte',
    AtNewAddress: 'À une autre adresse',
    CancelButton: 'Annuler',
    PreviousButton: 'Précédent',
    ClosedEventButton: 'Fermé',
    CreateEventButton: 'Créer un événement',
    CreateNewEvents: 'Créer un nouvel événement',
    EmailAddress: 'Adresse e-mail',
    EventAddressError: 'L\'adresse de l\'\u00e9vénement est requise',
    EventCommission: 'Commission',
    EventConsultantError: 'Votre session a expiré, veuillez vous reconnecter',
    EventDate: 'Date',
    EventDateError: 'La date de l\'\u00e9vénement est requise',
    EventTimeError: 'L\'heure de début ne peut pas être après l\'heure de fin',
    EventPastDateError: 'L\'\u00e9vénement ne peut pas être planifié dans le passé',
    EventHostAddError: 'Le prénom, le nom, l\'e-mail et le numéro de téléphone de l\'hôte sont requis',
    HostInfoError: 'Veuillez remplir le prénom, le nom de l\'hôte et soit le téléphone, soit l\'e-mail',
    HostAddressError: 'Veuillez remplir tous les champs d\'adresse de l\'hôte',
    EventHostess: 'Hôte',
    EventId: 'Événement',
    EventLocation: 'Lieu',
    EventEndTime: 'Fin',
    EventStartTime: 'Début',
    EventTitle: 'Nom',
    EventTitleError: 'Le nom de l\'\u00e9vénement est requis',
    EventTotal: 'Total',
    FindHost: 'Trouver l\'hôte',
    FindHostError: 'Veuillez sélectionner un hôte',
    FirstName: 'Prénom',
    HostAddress: 'Adresse de l\'hôte',
    HostInformation: 'Informations sur l\'hôte',
    IAmHost: 'Je suis l\'hôte',
    LastName: 'Nom',
    MyEvents: 'Mes événements',
    NewEventButton: 'Nouvel événement',
    NewEventStep1: 'Étape 1 : Choisissez le type d\'\u00e9vénement que vous souhaitez créer',
    NewEventStep2: 'Étape 2 : Choisissez le pays dans lequel l\'\u00e9vénement aura lieu',
    NewEventStep3: 'Étape 3 : Choisissez l\'hôte de l\'\u00e9vénement',
    NewEventStep4: 'Étape 4 : Choisissez le titre et l\'heure de l\'\u00e9vénement',
    NewEventStep5: 'Étape 5 : Choisissez le lieu de l\'\u00e9vénement',
    NewEventStep6: 'Que souhaitez-vous faire ensuite ?',
    SaveAndFinish: 'Enregistrer et terminer',
    SaveAndFinishDescription: 'Enregistrez l\'\u00e9vénement dans votre calendrier et retournez à votre page de compte.',
    HostPortal: 'Portail hôte',
    HostPortalDescription: 'Enregistrez l\'\u00e9vénement et accédez au portail hôte. Choisissez un thème et envoyez à l\'hôte un e-mail avec les données d\'accès.',
    InviteGuests: 'Inviter des invités',
    InviteGuestsDescription: 'Enregistrez l\'\u00e9vénement et accédez à la gestion des invités pour ajouter des invités à l\'\u00e9vénement.',
    NextButton: 'Suivant',
    OpenEventButton: 'Ouvert',
    PhoneNumber: 'Numéro de téléphone',
    SearchButton: 'Rechercher',
    SearchHost: 'Recherchez dans votre carnet d\'adresses par prénom, nom, e-mail ou numéro de téléphone',
    EventStatus: 'Statut',
    SearchEvents: 'Rechercher des événements par nom, ID ou hôte...',
    ClearSearch: 'Effacer la recherche',
    NoEventsFound: 'Aucun événement trouvé',
  },
  eventTypes: {
    Party: 'Atelier',
    InPersonEvent: 'Événement en présentiel',
    FacebookParty: 'Événement Facebook',
    WhatsAppParty: 'Événement WhatsApp',
    Unknown: 'Inconnu',
  },
  invoice: {
    CartNumber: 'Numéro de panier',
    Name: 'Nom',
    Email: 'E-mail',
    Phone: 'Téléphone',
    EventName: 'Nom de l\'événement',
    InvoiceHeader: 'Paiement de facture',
    InvoiceInstruction: 'Payez le solde restant de la facture pour votre commande. <br/>Consultez votre facture ci-dessous et utilisez le bouton Ajouter un paiement pour sélectionner un mode de paiement.',
    InvoiceNumber: 'Numéro de facture',
    OrderDate: 'Date de commande',
    OrderInformation: 'Informations sur la commande',
    OrderReference: 'Référence de commande',
    ShippingAddress: 'Adresse de livraison',
    SubmitButton: 'Soumettre le paiement',
    NewSubmitButton: 'COMMANDER ET PAYER',
    EmailLabel: 'Adresse e-mail',
    EmailPlaceholder: 'Entrez votre adresse e-mail',
    VerifyIdentityButton: 'Vérifier l\'identité',
    InvoiceNotFound: 'Facture introuvable. Veuillez vérifier le numéro de facture et réessayer.',
    VerifyIdentityInstruction: 'Veuillez entrer votre adresse e-mail pour vérifier votre identité et accéder à cette facture.',
    VerifyIdentityFailed: 'L\'adresse e-mail ne correspond pas à nos enregistrements. Veuillez réessayer.'
  },
  payment: {
    CreateInvoiceButton: 'Facturer {0} {1}',
    InvoiceHeader: 'Envoyer une facture',
    InvoiceIssueDate: 'Date d\'émission',
    InvoiceNumber: 'Numéro de facture',
    InvoiceStatus: 'Statut de la facture',
    InvoicePaymentEntry: 'Envoyez une facture à {0} {1} pour collecter le paiement. Le client se verra proposer plusieurs options de paiement au moment du paiement.',
    ResendInvoiceButton: 'Renvoyer la facture à {0} {1}',
    BankPaymentHeader: 'Payer avec un compte bancaire',
    BankPaymentEntry: 'Effectuez un paiement en utilisant votre compte bancaire, {0} {1}.',
    YourBankDetails: 'Vos coordonnées bancaires',
    AccountHolder: 'Titulaire du compte',
    AccountNumber: 'Numéro de compte',
    RoutingNumber: 'Code bancaire',
    PaymentAmount: 'Montant du paiement',
    PayWithBank: 'Payer avec un compte bancaire',
    Processing: 'Traitement en cours...',
    NoBankDetailsFound: 'Aucune coordonnée bancaire trouvée. Veuillez ajouter vos coordonnées bancaires pour utiliser ce mode de paiement.',
  },
  productReview: {
    AddReviewButton: 'Ajouter un avis',
    EditReviewButton: 'Modifier l\'avis',
    CompleteHeader: 'Merci !',
    CompleteSubHeader: 'Votre avis a été soumis et sera publié une fois approuvé.',
    CreateReview: 'Créer un avis',
    ErrorHeader: 'Erreur !',
    ErrorFileSize: 'Veuillez vérifier la taille des fichiers que vous joignez, ils peuvent être trop volumineux.',
    ErrorLoggedIn: 'Vous devez être connecté pour créer un avis',
    ErrorReviewComment: 'Le commentaire est requis',
    ErrorOverallRating: 'La note est requise',
    ErrorSubHeader: 'Votre avis n\'a pas été soumis.',
    OverallRating: 'Note globale',
    Review5Star: 'Excellent',
    Review4Star: 'Bon',
    Review3Star: 'Moyen',
    Review2Star: 'En dessous de la moyenne',
    Review1Star: 'Mauvais',
    ReviewAnonymous: 'Faire apparaître l\'avis comme anonyme, si non coché votre nom s\'affichera avec votre avis',
    ReviewAttachment: 'Ajouter une photo ou une vidéo',
    ReviewByAnonymous: 'Anonyme',
    ReviewComment: 'Ajouter un avis écrit',
    ReviewPending: 'Avis en attente d\'approbation',
    ReviewHeader: 'Avis',
    ReviewSubmit: 'Soumettre l\'avis',
    ReviewTotalPart1: 'de',
    ReviewTotalPart2: 'avis',
    CommentPlaceholder: 'Qu\'avez-vous aimé ou n\'avez-vous pas aimé ? Pourquoi avez-vous utilisé ce produit ?',
    ReviewImageAlt: 'Image de l\'avis produit',
    ClickToUpload: 'Cliquez pour sélectionner des fichiers ou faites-les glisser ici',
    SupportedFormats: 'JPEG, PNG, JPG, GIF, MP4',
    RemoveFileTitle: 'Supprimer le fichier',
    Uploaded: 'Téléchargé',
    Failed: 'Échoué',
    ExistingAttachments: 'Photos et vidéos actuelles',
    DeleteAttachment: 'Supprimer cette pièce jointe',
    Delete: 'Supprimer',
    DeleteAttachmentConfirm: 'Êtes-vous sûr de vouloir supprimer cette pièce jointe ? Cette action ne peut pas être annulée.',
    ErrorDeletingAttachment: 'Échec de la suppression de la pièce jointe. Veuillez réessayer.',
  },
  wishList: {
    CreateList: 'Créer une liste',
    CreateListButton: 'Créer une liste',
    PageHeader: 'Ma liste',
    PlaceHolderWishListName: 'Entrez un nom pour votre liste',
    WishListButton: 'Ma liste de souhaits',
    WishListDetailHeader: 'Mes listes de souhaits',
    WishListHeader: 'Ma liste de souhaits',
    WishListItems: 'Articles',
    WishListSaveTo: 'Enregistrer dans',
    RemoveFromWishlist: 'Retirer de la liste de souhaits',
  },
  terms: {
    agreement: 'En cliquant sur le bouton "Devenir conseiller·ère", vous acceptez nos {termsLink} de notre {privacyLink}',
    checkoutAgreement: 'En cliquant sur  « Commander et payer », vous confirmez votre commande avec obligation de paiement et acceptez les {termsLink}. Vos données personnelles sont traitées conformément à notre {privacyLink} afin de traiter et d’exécuter votre commande.',
    checkoutTermsOfUse: 'Conditions générales de vente',
    checkoutPrivacyPolicy: 'Politique de confidentialité',
    termsOfUse: 'CONDITIONS GÉNÉRALES DE VENTE',
    privacyPolicy: 'POLITIQUE DE CONFIDENTIALITÉ',
    certification: "Je certifie que j'ai 18 ans ou plus et que j'ai lu et accepté les termes de l'{consultantAgreementLink}",
    independentConsultantAgreement: 'Accord de Consultant Indépendant',
    ethics: "J'accepte et j'ai lu les {prohibitedBusinessPracticesLink} et le {codeOfEthicsLink} de H+BH",
    prohibitedBusinessPractices: 'Pratiques commerciales interdites',
    codeOfEthics: "Code d'éthique",
    prohibitedBusinessPracticesUrl: 'https://pamperedchef.widen.net/s/lvq8nqktzt/prohibited-business-practices-fr',
    codeOfEthicsUrl: 'https://pamperedchef.widen.net/s/qzhlhszvv7/berkshire-code-of-conduct-fr',
    showMore: 'Afficher plus'
  },
  languages: {
    en: 'Anglais',
    fr: 'Français',
    es: 'Espagnol',
    de: 'Allemand',
    it: 'Italien',
  },
  alerts: {
    Success: 'Succès',
    InvoiceChange: 'Action sur la facture',
    CancelInvoiceConfirm: 'Voulez-vous vraiment annuler cette facture ?',
    ResendInvoiceConfirm: 'Voulez-vous vraiment renvoyer cette facture ?',
    InvoiceCancelled: 'La facture a été annulée avec succès.',
    InvoiceResent: 'La facture a été renvoyée avec succès.',
    FailedToCancelInvoice: 'Échec de l\'annulation de la facture. Veuillez réessayer.',
    FailedToResendInvoice: 'Échec du renvoi de la facture. Veuillez réessayer.',
    CannotCancelInvoice: 'Cette facture ne peut pas être annulée car elle est déjà annulée ou payée.',
    CannotResendInvoice: 'Cette facture ne peut pas être renvoyée car elle est déjà annulée ou payée.',
    AddedToCart: 'Ajouté au panier !',
    AddToCartError: 'Erreur d\'ajout au panier',
    NoQuantityAvailable: 'Il n\'y a pas assez d\'articles en stock pour en ajouter plus au panier',
    HostOnlyItemTitle: 'Article réservé à l\'hôte',
    HostOnlyItemMessage: 'Cet article est uniquement disponible pour les paniers hôte et ne peut pas être ajouté à un panier invité.',
    HostOnlyItemButton: 'Hôte uniquement',
    DiscountOnlyItemTitle: 'Article réservé aux remises',
    DiscountOnlyItemMessage: 'Cet article ne peut être ajouté que dans le cadre d\'une récompense de remise et non manuellement.',
    DiscountOnlyItemButton: 'Remise uniquement',
    ValidationError: 'Erreur de validation',
    DeleteConfirmTitle: 'Supprimer',
    DeleteConfirm: 'Êtes-vous sûr de vouloir supprimer : {0}',
    NoPermissions: 'Vous n\'avez pas les permissions pour effectuer cette action. ({0})',
    UnsavedChanges: 'Vous avez des modifications non enregistrées. Voulez-vous les enregistrer ?',
    ProductEligibilityQuantityGatewayException: 'La quantité maximale autorisée pour ce produit est de {ruleQuantity}.',
    ProductEligibilityOrderTotalGatewayException: 'Le montant total de la commande {orderTotal} dépasse le plafond du montant total de la commande de {orderTotalCap}.',
    PoeDiscCouponNotFoundException: 'Le coupon que vous essayez d\'utiliser est invalide.',
    PoeDiscCouponDiscountPlanNotFoundException: 'Le coupon que vous essayez d\'utiliser n\'est pas valable pour cette commande.',
    SingleUseOrderLimitTitle: 'Limite de commande atteinte',
    SingleUseOrderLimitMessage: 'Vous avez déjà passé une commande. Une seule commande Kit Enhancement est autorisée.',
    AOEPaymentMappingException: {
      CREDIT_CARD_NUMBER_MUST_BE_TEST_NUMBER: 'Le numéro de carte de crédit n\'est pas un numéro de test accepté',
      DO_NOT_HONOR: 'Paiement refusé par l\'émetteur de la carte',
      INSUFFICIENT_FUNDS: 'Fonds insuffisants',
      INVALID_NUMBER: 'Numéro de carte invalide',
    },
    CartSubmit: {
      UnknownError: 'Le panier n\'a pas pu être soumis en raison d\'une erreur inconnue',
      NotBalanced: 'Le panier n\'a pas pu être soumis car il est déséquilibré',
      SkuWarehouseNotFound: 'Le panier n\'a pas pu être soumis car l\'entrepôt pour {SkuCode} n\'a pas été trouvé',
      SkuWarehouseNotAvailable: 'Le panier n\'a pas pu être soumis car {SkuCode} n\'est pas disponible à l\'entrepôt',
      SkuWarehouseStopSell: 'Le panier n\'a pas pu être soumis car {SkuCode} est en rupture de stock à l\'entrepôt',
      CouponAlreadyUsed: 'Ce coupon a déjà été utilisé et ne peut pas être appliqué à nouveau',
      ShippingAddressMissing: 'Le panier n\'a pas pu être soumis car l\'adresse de livraison est manquante',
      ShippingMethodMissing: 'Le panier n\'a pas pu être soumis car la méthode d\'expédition est manquante',
    },
    CartSubmitSuccessTitle: 'Succès !',
    CartSubmitSuccess: 'Votre panier a été soumis',
    AOESkuWarehouseReservationCreateException: 'Le panier n\'a pas pu être soumis car un ou plusieurs articles ne sont plus disponibles',
    AOEInvoiceCartNotFoundException: 'Facture introuvable',
    AOECartInvoiceStatusInvalidException: 'La facture ne peut plus être payée',
    PoeDiscCouponAlreadyUsedException: 'Ce coupon a déjà été utilisé et ne peut pas être appliqué à nouveau',
    AOESkuExpiredException: "Le SKU '{skuCode}' n'est plus disponible. Veuillez le retirer de votre panier pour passer à la caisse.",
    AOESkuShippingRestrictionException: "Le SKU '{skuCode}' n'est pas disponible pour le mode de livraison sélectionné",
    AOECountryShippingRestrictionException: "Le mode de livraison sélectionné n'est pas disponible pour le pays '{countryCode}'",
    BeeAddressBookReferencedByEventException: 'Ce contact ne peut pas être supprimé car il est lié à un ou plusieurs événements. Veuillez retirer le contact de tous les événements avant de le supprimer.',
    GeneralError: 'Une erreur est survenue lors du traitement de votre demande ({messageKey})',
    AxiosError: 'Une erreur est survenue lors du traitement de votre demande : {message} ({name} {code})',
    FailedToGetCurrentBatchNumber: 'Impossible de récupérer le numéro de lot actuel.'
  },
  accountInfo: {
    title: 'Gestion du compte',
    personalData: {
      title: 'Demander des données personnelles',
      description: 'Demandez une copie de vos données personnelles ou une suppression',
      updateTitle: 'Demande de données personnelles',
      updateDescription: 'Demandez vos données personnelles ou la suppression de votre compte. Nous traiterons votre demande conformément aux lois applicables en matière de confidentialité.',
      selectRequest: 'Sélectionnez votre demande :',
      exportData: 'Exporter les données personnelles',
      deleteData: 'Supprimer les données personnelles',
      emailAddress: 'Votre adresse e-mail (obligatoire) :',
      emailPlaceholder: 'Entrez votre adresse e-mail',
      sendRequest: 'Envoyer la demande',
      emailRequired: 'L\'adresse e-mail est requise',
      emailInvalid: 'Veuillez entrer une adresse e-mail valide',
      emailMismatch: 'L\'adresse e-mail saisie est invalide.',
      optionRequired: 'Veuillez sélectionner une option de demande',
      exportSuccess: 'Votre demande d\'exportation a été soumise avec succès. Vous pouvez maintenant télécharger votre rapport au format PDF.',
      deleteSuccess: 'Votre demande de suppression de données a été soumise avec succès.',
      submitError: 'Échec de l\'envoi de la demande. Veuillez réessayer.',
      exportOptionsTitle: 'Votre exportation de données personnelles',
      exportOptionsDescription: 'Votre demande d\'exportation a été traitée. Vous pouvez télécharger le rapport au format PDF.',
      downloadPDF: 'Télécharger le rapport PDF',
      viewReport: 'Voir le rapport',
      reportTitle: 'Rapport d\'exportation des données personnelles',
      newRequest: 'Faire une nouvelle demande',
      pdfNoProfileDataError: 'Aucune donnée de profil disponible. Veuillez soumettre la demande à nouveau.',
      pdfNoAddressDataError: 'Les données d\'adresse n\'ont pas été chargées. Veuillez soumettre la demande à nouveau.',
      pdfComponentNotReadyError: 'Le composant d\'export PDF n\'est pas prêt. Veuillez réessayer.',
      pdfDownloadFailedError: 'Le téléchargement du PDF a échoué. Veuillez réessayer ou utiliser la fonction d\'impression de votre navigateur.',
      reportHeader: 'Exportation des données personnelles',
      businessInformation: 'Informations commerciales :',
      personalInformation: 'Informations personnelles :',
      contactInformation: 'Informations de contact :',
      phoneNumbers: 'Numéros de téléphone :',
      addresses: 'Adresses :',
      governmentIds: 'Pièces d\'identité :',
      governmentIdType: 'Type de pièce :',
      taxPayerIdLastFour: 'Quatre derniers chiffres :',
      noGovernmentIdsOnFile: 'Aucune pièce d\'identité enregistrée.',
      customerNumber: 'Numéro client :',
      dateOfBirth: 'Date de naissance :',
      username: 'Nom d\'utilisateur :',
      anniversary: 'Anniversaire :',
      name: 'Nom :',
      social: 'Réseaux sociaux :',
      firstName: 'Prénom :',
      lastName: 'Nom :',
      preferredName: 'Nom préféré :',
      alternativeFirstName: 'Prénom alternatif :',
      alternativeLastName: 'Nom alternatif :',
      webUrl: 'URL Web :',
      imHandle: 'Identifiant IM :',
      facebook: 'Facebook :',
      twitter: 'Twitter :',
      linkedIn: 'LinkedIn :',
      pinterest: 'Pinterest :',
      reportEmailAddress: 'Adresse e-mail :',
      home: 'Domicile',
      mobile: 'Mobile',
      fax: 'Fax',
      work: 'Travail',
      shippingAddress: 'Adresse de livraison',
      billingAddress: 'Adresse de facturation',
      mailingAddress: 'Adresse postale',
      addressName: 'Nom :',
      company: 'Entreprise :',
      addressLine1: 'Adresse ligne 1 :',
      addressLine2: 'Adresse ligne 2 :',
      city: 'Ville :',
      stateProvince: 'État/Province :',
      postalCode: 'Code postal :',
      country: 'Pays :',
      noAddressesOnFile: 'Aucune adresse enregistrée.',
      reportFooterText: 'Rapport d\'exportation des données personnelles - généré le',
      requestType: 'Type de demande : exportation de données',
      notAvailable: 'N/D'
    },
    orderHistory: {
      title: 'Historique des commandes',
      description: 'Consultez vos commandes passées et suivez vos expéditions',
      updateTitle: 'Historique des commandes',
      updateDescription: 'Consultez et gérez votre historique de commandes ici.',
      loadError: 'Impossible de charger l\'historique des commandes',
      errorLoading: 'Erreur lors du chargement de l\'historique des commandes. Veuillez réessayer.',
      ordersFound: '{count} commandes trouvées',
      orderNumber: 'Numéro de commande',
      orderDate: 'Date de commande',
      viewReceipt: 'Voir le reçu',
      orderType: 'Type de commande',
      customer: 'Client',
      tracking: 'Suivi',
      commissionValue: 'Valeur de commission',
      noOrders: 'Aucune commande trouvée',
      noOrdersDescription: 'Vous n\'avez pas encore de commandes dans votre historique.',
      showingResults: 'Affichage de {start}-{end} sur {total} résultats',
      itemsPerPage: 'Éléments par page',
      orderDetails: 'Détails de la commande',
      orderInformation: 'Informations sur la commande',
      customerInformation: 'Informations client',
      shippingInformation: 'Informations de livraison',
      commissionInformation: 'Informations sur la commission',
      orderTotal: 'Total de la commande',
      customerName: 'Nom du client',
      customerEmail: 'E-mail du client',
      additionalDetails: 'Détails supplémentaires',
      detailsLoaded: 'Détails chargés',
      noDetailToken: 'Informations détaillées non disponibles pour cette commande',
      orderSummary: 'Récapitulatif de la commande',
      shippingCost: 'Frais de livraison',
      taxAmount: 'Montant de la taxe',
      orderTypeId: 'ID du type de commande',
      productDetails: 'Détails du produit',
      skuCode: 'Code SKU',
      productName: 'Nom du produit',
      productImage: 'Produit',
      quantity: 'Quantité',
      price: 'Prix',
      lineTotal: 'Total de la ligne',
      detailLoadError: 'Impossible de charger les détails de la commande',
      orderStatus: 'Statut de la commande',
      paymentDetails: 'Détails du paiement',
      subtotal: 'Sous-total',
      paymentMethod: 'Mode de paiement',
      paymentProcessed: 'Traité',
      paymentAuthorized: 'Autorisé',
      paymentRefunded: 'Remboursé',
      authCode: 'Code d\'autorisation',
      shippingTo: 'Expédier à',
      shippingMethod: 'Mode d\'expédition',
      discount: 'Remise',
      shippingAndHandling: 'Expédition et manutention',
      inTotal: 'TOTAL',
      billingAddress: 'Adresse de facturation'
    },
    billingAddress: {
      title: 'Adresse de facturation et de livraison',
      description: 'Mettez à jour vos informations d\'adresse de facturation et de livraison',
      updateTitle: 'Mettre à jour l\'adresse de facturation et de livraison',
      updateDescription: 'Cette fonctionnalité sera bientôt disponible. Vous pourrez mettre à jour vos informations d\'adresse de facturation et de livraison ici.',
      noAddressSet: 'Aucune adresse de facturation définie',
      change: 'Modifier',
      addNew: 'Ajouter nouveau',
      editAddress: 'Modifier l\'adresse',
      addNewAddress: 'Ajouter une nouvelle adresse',
      saveSuccess: 'Adresse enregistrée avec succès',
      saveError: 'Échec de l\'enregistrement de l\'adresse',
      selectAddress: 'Sélectionner',
      currentBilling: 'Adresse de facturation',
      currentShipping: 'Adresse de livraison',
      createNew: 'Créer une nouvelle adresse',
      addressUpdated: 'Adresse mise à jour avec succès',
      updateError: 'Échec de la mise à jour de l\'adresse',
      requiredFields: 'Veuillez remplir les champs obligatoires suivants',
      billing: 'Facturation',
      shipping: 'Livraison',
      noBillingAddress: 'Aucune adresse de facturation',
      noShippingAddress: 'Aucune adresse de livraison',
      addBillingAddress: 'Ajouter une adresse de facturation',
      addShippingAddress: 'Ajouter une adresse de livraison',
      deleteAddress: 'Supprimer l\'adresse',
      deleteConfirmTitle: 'Supprimer l\'adresse ?',
      deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer cette adresse ? Cette action ne peut pas être annulée.',
      deleteSuccess: 'Adresse supprimée avec succès',
      deleteError: 'Échec de la suppression de l\'adresse',
      cannotDeleteTitle: 'Impossible de supprimer l\'adresse',
      cannotDeleteMessage: 'Cette adresse ne peut pas être supprimée car elle est actuellement définie comme votre adresse de {type}. Veuillez d\'abord sélectionner une autre adresse.',
      defaultBadge: 'Par défaut'
    },
    contactDetails: {
      title: 'Modifier l\'e-mail, le mot de passe et les coordonnées',
      description: 'Mettez à jour votre adresse e-mail, votre mot de passe et vos coordonnées',
      updateTitle: 'Informations de contact',
      updateDescription: 'Gérez votre adresse e-mail, votre mot de passe et vos autres informations de contact.',
      changeEmailPassword: 'Modifier l\'e-mail et le mot de passe',
      currentPassword: 'Mot de passe actuel *',
      currentPasswordPlaceholder: 'Entrez votre mot de passe actuel',
      currentPasswordRequired: 'Le mot de passe actuel est requis',
      currentPasswordTooShort: 'Le mot de passe actuel doit comporter au moins 8 caractères',
      newPassword: 'Nouveau mot de passe',
      newPasswordPlaceholder: 'Entrez le nouveau mot de passe',
      newPasswordRequired: 'Le nouveau mot de passe est requis',
      newPasswordTooShort: 'Le nouveau mot de passe doit comporter au moins 8 caractères',
      newPasswordWeak: 'Le mot de passe doit contenir une majuscule, une minuscule, un chiffre et un caractère spécial',
      newPasswordSameAsCurrent: 'Le nouveau mot de passe doit être différent du mot de passe actuel',
      confirmPassword: 'Confirmer le nouveau mot de passe',
      confirmPasswordPlaceholder: 'Confirmez votre nouveau mot de passe',
      confirmPasswordRequired: 'Veuillez confirmer votre nouveau mot de passe',
      passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
      passwordChangeSuccess: 'Mot de passe modifié avec succès',
      passwordChangeError: 'Échec de la modification du mot de passe. Veuillez vérifier votre mot de passe actuel.',
      accountDetailsSuccess: 'Détails du compte enregistrés avec succès',
      accountDetailsError: 'Échec de l\'enregistrement des détails du compte. Veuillez réessayer.',
      passwordChangeTitle: 'Mot de passe',
      changePassword: 'Modifier le mot de passe',
      accountDetailsTitle: 'Détails du compte',
      firstName: 'Prénom',
      firstNamePlaceholder: 'Entrez votre prénom',
      lastName: 'Nom',
      lastNamePlaceholder: 'Entrez votre nom',
      emailAddress: 'Entrez votre adresse e-mail',
      emailAddressPlaceholder: 'Entrez votre adresse e-mail',
      phoneCountry: 'Téléphone',
      phoneNumber: 'Numéro de téléphone',
      phoneNumberPlaceholder: '(123) 456-7890',
      mobileCountry: 'Mobile',
      mobileNumber: 'Numéro de mobile',
      mobileNumberPlaceholder: '(123) 456-7890',
      saveAccountDetails: 'Enregistrer les détails du compte',
    },
    termsConditions: {
      title: 'Conditions générales',
      description: 'Voir les conditions générales',
      updateTitle: 'Conditions générales',
      updateDescription: 'Consultez les conditions générales actuelles de votre compte.'
    },
    dataProvisions: {
      title: 'Politique de confidentialité',
      description: 'Voir la politique de confidentialité',
      updateTitle: 'Paramètres de confidentialité',
      updateDescription: 'Modifiez vos préférences de consentement marketing et gérez vos préférences de confidentialité.',
      termsId: 'ID global',
      contractName: 'Nom du contrat',
      version: 'Version',
      acknowledgedDate: 'Date de signature',
      deliveredOn: 'Livré le',
      signByDate: 'Date limite de signature',
      status: 'Statut',
      statusAccepted: 'Accepté',
      statusDeclined: 'Refusé',
      statusPending: 'En attente',
      noContracts: 'Aucune politique de confidentialité trouvée',
      noContractsDescription: 'Vous n\'avez actuellement aucune politique de confidentialité ou contrat disponible.',
      errorNoUser: 'Aucun utilisateur authentifié trouvé',
      errorLoading: 'Erreur lors du chargement de la politique de confidentialité. Veuillez réessayer.'
    },
    marketingOptIn: {
      title: 'Consentement marketing',
      description: 'Gérez vos préférences de communication marketing',
      updateTitle: 'Préférences marketing',
      updateDescription: 'Choisissez les communications marketing que vous souhaitez recevoir.',
      errorLoading: 'Échec du chargement des préférences marketing',
      errorSaving: 'Échec de l\'enregistrement des préférences marketing',
      errorNoUser: 'Aucune information utilisateur disponible',
      saveSuccess: 'Préférences marketing enregistrées avec succès',
      noChangesToSave: 'Aucune modification à enregistrer',
      optedIn: 'Accepté',
      optedOut: 'Refusé',
      lastModified: 'Dernière modification',
      noOptionsTitle: 'Aucune option marketing disponible',
      noOptionsDescription: 'Aucune option de communication marketing n\'est actuellement disponible pour votre compte.'
    },
  },
  columns: {
    birthDate: 'Date de naissance',
    birthDatePlaceholder: 'Jour/Mois/Année',
    countryCode: 'Code du pays',
    country: 'Nom du pays',
    currencyId: 'Devise',
    state: 'Nom de l\'état',
    countryCodeIsoalpha3: 'ISO 3',
    isEnabled: 'Activé',
    templateName: 'Nom du modèle',
    templateDescription: 'Description',
    schemaName: 'Nom du schéma',
    cultureName: 'Nom de la culture',
    messageBody: 'Corps du message',
    documentName: 'Nom du document',
    documentSubject: 'Objet du document',
    codeIdClassification: 'Classification',
    firstName: 'Prénom',
    lastName: 'Nom de famille',
    emailAddress: 'E-mail',
    password: 'Mot de passe',
    confirmPassword: 'Confirmer le mot de passe',
    phone: 'Numéro de téléphone',
    city: 'Ville',
    addressLine1: 'Adresse',
    addressLine2: 'Apt, Suite, etc',
    stateCode: 'État/Province',
    postalCode: 'Code postal',
    addressFirstName: 'Prénom',
    addressLastName: 'Nom de famille',
    title: 'Titre',
    companyName: 'Entreprise',
    primaryPhone: {
      number: 'Numéro de téléphone'
    },
    primaryPhoneNumber: 'Numéro de téléphone',
    alt1PhoneNumber: 'Numéro de téléphone alternatif',
    alt2PhoneNumber: 'Numéro de téléphone alternatif 2',
    alt3PhoneNumber: 'Numéro de téléphone alternatif 3',
    preferredName: 'Nom préféré',
    billingFirstName: 'Prénom',
    billingLastName: 'Nom de famille',
    facebookId: 'Facebook',
    linkedInId: 'LinkedIn',
    twitterId: 'Twitter',
    pinterestId: 'Pinterest',
  },
  consultantLocator: {
    welcomeHeader: "Nous sommes ravis de t'accueillir parmi nous!",
    teamJoiningHeader: "Quelle équipe vas-tu choisir?",
    searchByText: "Trouvez le conseiller qui vous convient",
    nameTab: "Nom",
    locationTab: "Emplacement",
    country: "Pays",
    countryDE: "Allemagne",
    countryAT: "Autriche",
    countryFR: "France",
    directSignupText: "Tu n'as pas encore de conseillère à tes côtés? Coche simplement la case et commence directement avec nous.",
    directSignupError: "Impossible de traiter l'inscription directe. Veuillez réessayer ou contacter le support.",
    whyJoinConsultantQuestion: "Vous ne vous lancez pas seul",
    whyJoinConsultantPersonal: "Vous ne vous lancez pas seul",
    consultantTeamInfo: "Chez Pampered Chef, nous accordons une grande importance à l'accompagnement personnalisé. Avec un conseiller à vos côtés, vous bénéficiez à tout moment d'un soutien, de conseils et d'un interlocuteur attitré.",
    experienceInfo: "Nous veillons ainsi à ce que vos débuts et votre parcours chez Pampered Chef soient agréables, transparents et couronnés de succès.",
    selectDifferentConsultant: "Sélectionner un autre conseiller",
    selectAndContinue: "Sélectionner et continuer",
    consultantsFound: "Consultants trouvés",
    noConsultantsFound: "Aucun consultant trouvé dans cette zone. Veuillez essayer un autre code postal.",
    enterConsultantName: "Entrez le prénom ou le nom",
    enterZipCode: "Entrez le code postal",
    searchRadius: "Rayon de recherche",
    kilometers: "km"
  },

partyOrderEntry: {
    Actions: 'Supprimer',
    ActiveCartHeader: 'Actif',
    AddGuestButton: 'Ajouter un invité',
    AddGuestSectionHeader: 'Ajouter un invité',
    ProductSubtotalByCategory: 'Sous-total des produits par catégorie',
    PriceCategoryName: 'Catégorie',
    SumTotalPrice: 'Prix total',
    Discount: 'Remise %',
    FinalSum: 'Somme finale',
    BuyingDiscount: 'Remise d\'achat',
    AddNewAddress: 'Nouvelle adresse',
    AddNewCustomerButton: 'Ajouter un nouveau client',
    AddCustomerEmailButton: 'Ajouter un client existant',
    Available: 'Disponible',
    BalanceHeader: 'Solde',
    BecomeAConsultant: 'Intéressé à devenir consultant',
    CancelHostingEvent: 'Annuler',
    CatalogEntry: 'Catalogue',
    CatalogRetailPrice: 'Prix de vente',
    CatalogYourPrice: 'Votre prix',
    Category: 'Catégorie',
    CategoryEntry: 'Catégorie',
    CategoryEntryBuyingDiscountHeader: 'Remise d\'achat',
    CategoryEntryHeader: 'Sélectionner une catégorie',
    CategoryEntryItemHeader: 'Article #',
    CategoryEntryProductHeader: 'Produit',
    CategoryEntryRetailHeader: 'Prix',
    CategoryEntryUOMHeader: 'Unité de mesure',
    CategoryEntryYourPriceHeader: 'Votre prix',
    ChangeAddressButton: 'Modifier',
    ChangeAddressNewAddress: 'Nouvelle adresse',
    ChangeAddressError: 'Veuillez sélectionner une adresse',
    ChangeAddressPopupHeader: 'Modifier l\'adresse consolidée',
    ChangeAddressPopupSubHeader: 'Choisissez une adresse existante dans la liste ou entrez une nouvelle adresse pour l\'adresse consolidée',
    ConsolidatedAddress: 'Adresse consolidée',
    ConsultantName: 'Consultant',
    ConsultantSummary: 'Consultant',
    CreditCartSubmit: 'Ajouter un paiement',
    CustomerNameHeader: 'Nom',
    DetailsHeader: 'Article',
    DiscountHeader: 'Remise',
    DiscountSectionHeader: 'Remises et offres spéciales',
    EventDate: 'Date de l\'événement',
    EventId: 'Événement',
    FreeDollarCoupons: 'Vous pouvez utiliser une partie de vos dollars d\'hôtesse pour un coupon',
    FreeDollarCouponsBtn: 'Consultez les coupons disponibles',
    FreeDollarCouponsPopupHeader: 'Coupons disponibles',
    FreeDollarCouponsRemoveBtn: 'Supprimer le coupon',
    FreeDollarItemSelect: 'Sélectionnez l\'article sur lequel vous souhaitez recevoir une remise en dollars gratuits',
    GridFooterTotal: 'Total',
    GuestListAdd: 'Invités (+)',
    GuestName: 'Invité',
    GuestOrderHeaderSectionHeader: 'Commande d\'invité',
    Host: 'Hôte',
    HostAParty: 'Intéressé à organiser une fête',
    HostOrderHeaderSectionHeader: 'Commande de l\'hôte',
    HostSummary: 'Résumé de l\'hôte',
    ItemEntry: 'Saisie d\'article',
    ItemNotAvailable: 'En rupture de stock',
    LowStock: 'Stock faible',
    MakePaymentTitle: 'Effectuer un paiement',
    MissingPricing: 'Prix non disponible',
    NumberOfGuests: 'Invités',
    NumberOfGuestOrders: 'Commandes des invités',
    PartyDate: 'Date de la fête',
    PaymentCharge: 'Montant',
    PaymentName: 'Nom',
    PaymentReference: 'Référence',
    PaymentStatus: 'Statut',
    PaymentType: 'Type',
    ProductImageHeader: 'Image',
    PSHeader: 'PS',
    Options: 'Options',
    OrderNumberHeader: 'N° de commande',
    OrderSummary: 'Résumé de la commande',
    OrderSummaryBalanceDue: 'Solde dû',
    OrderSummaryDiscount: 'Remise',
    OrderSummaryDonations: 'Dons',
    OrderSummaryFees: 'Frais',
    OrderSummaryPaymentsMade: 'Paiements effectués',
    OrderSummaryProductSubtotal: 'Sous-total des produits',
    OrderSummarySectionHeader: 'Résumé de la commande',
    OrderSummaryShipping: 'Expédition',
    OrderSummarySubtotal: 'Sous-total',
    OrderSummaryTax: 'Taxe',
    OrderSummaryTotal: 'Total',
    OutOfStock: 'Non disponible',
    PartyOrderSummaryGuestOrdersSectionHeader: 'Commandes des invités',
    PartyOrderSummaryHostOrdersSectionHeader: 'Commande de l\'hôte',
    PaymentHeader: 'Paiements',
    PaymentSectionHeader: 'Informations de paiement',
    QuantityHeader: 'Qté',
    RetailHeader: 'Détail',
    SaveAddressButton: 'Enregistrer l\'adresse',
    SaveHostingEvent: 'Enregistrer',
    SelectDate: 'Choisir la date de l\'événement',
    ShipNowButton: 'Expédier maintenant',
    ShipNowHoverTitleBalance: 'Solde dû sur le panier',
    ShipNowHoverTitleNoItems: 'Aucun article dans le panier',
    ShipNowHoverTitleNoPayment: 'Aucun paiement sur le panier',
    ShippingAddressTitle: 'Adresse de livraison',
    ShippingCostHeader: 'Frais d\'expédition',
    ShippingSectionHeader: 'Informations d\'expédition',
    ShippingMethodsSectionHeader: 'Méthode d\'expédition',
    ShipMethodTypesTitle: 'Expédier avec',
    ShipToTypesTitle: 'Expédier à',
    SingleLineEntry: 'Ligne unique',
    Step1AddGuestLabel: 'Étape 1 : Choisir une option',
    Step2AddExistingGuestLabel: 'Étape 2 : Trouver l\'invité dans votre carnet d\'adresses',
    Step2AddNewGuestLabel: 'Étape 2 : Remplir les informations de l\'invité',
    StopSell: 'Épuisé',
    SubmitButton: 'Soumettre la fête',
    SubTotalHeader: 'Sous-total',
    TotalHeader: 'Total',
    UpdateCartButton: 'Mettre à jour le panier',
    ViewOrderReceipt: 'Voir le reçu de la commande',
    YourShoppingCart: 'Votre panier',
    NoResultsFound: 'Aucun résultat trouvé.',
    BackToEventManagement: 'Retour à la gestion des événements'
  },
  consultantOrderEntry: {
    CartSummaryHeader: 'Résumé du panier',
    ProceedToCheckout: 'Procéder au paiement',
    SubmitButton: 'Soumettre',
    ContinueShoppingButton: 'Continuer vos achats'
  },
  thankYou: {
    PageHeader: 'Merci pour votre commande !',
    SubHeader: 'Votre commande a été passée avec succès. Un e-mail de confirmation a été envoyé à l\'adresse e-mail que vous avez fournie.',
    DetailsAboutOrder: 'Détails de votre commande',
    orderNumber: 'Numéro de commande :',
    PaymentAmount: 'Montant du paiement',
    YourItems: 'Vos articles',
    shippingCost: 'Frais de livraison',
    total: 'Total TTC',
    totalTaxAmountInclude: 'Taxes incluses'
  },
  consultantCorner: {
    myAccountRenewalReminder: {
      message: 'Votre plan actuel se termine dans {days} jours. Vérifiez maintenant vos paramètres de renouvellement.',
      messageToday: 'Votre plan actuel expire aujourd\'hui. Vérifiez maintenant vos paramètres de renouvellement.',
      messageExpired: 'Votre plan actuel a pris fin. Vérifiez maintenant vos paramètres de renouvellement.',
      trialMessage: 'Votre période d\'essai se termine dans {days} jours. Vérifiez maintenant vos paramètres de renouvellement.',
      trialMessageToday: 'Votre période d\'essai expire aujourd\'hui. Vérifiez maintenant vos paramètres de renouvellement.',
      trialMessageExpired: 'Votre période d\'essai a pris fin. Vérifiez maintenant vos paramètres de renouvellement.',
      action: 'Aller aux Paramètres de Boutique Web',
      dismiss: 'Ignorer'
    },
    security: {
      passwordHeader: 'Changer le Mot de Passe',
      passwordSubHeader: 'Mettez à jour le mot de passe de votre compte pour une sécurité renforcée',
      oldPasswordLabel: 'Mot de Passe Actuel',
      oldPasswordPlaceholder: 'Entrez votre mot de passe actuel',
      newPasswordLabel: 'Nouveau Mot de Passe',
      newPasswordPlaceholder: 'Entrez votre nouveau mot de passe',
      confirmPasswordLabel: 'Confirmer le Nouveau Mot de Passe',
      confirmPasswordPlaceholder: 'Confirmez votre nouveau mot de passe',
      passwordRequirements: 'Exigences du Mot de Passe:',
      requirement1: 'Au moins 8 caractères de long',
      requirement2: 'Au moins une lettre minuscule',
      requirement3: 'Au moins une lettre majuscule',
      requirement4: 'Au moins un chiffre',
      requirement5: 'Au moins un caractère spécial',
      savePassword: 'Enregistrer le Mot de Passe',
      saving: 'Enregistrement...',
      oldPasswordRequired: 'Le mot de passe actuel est requis',
      newPasswordRequired: 'Le nouveau mot de passe est requis',
      newPasswordTooShort: 'Le mot de passe doit contenir au moins 8 caractères',
      newPasswordWeak: 'Le mot de passe ne répond pas aux exigences',
      newPasswordSameAsCurrent: 'Le nouveau mot de passe doit être différent du mot de passe actuel',
      confirmPasswordRequired: 'Veuillez confirmer votre nouveau mot de passe',
      passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
      passwordSaveSuccess: 'Mot de passe mis à jour avec succès',
      passwordSaveError: 'Échec de la mise à jour du mot de passe. Veuillez réessayer.'
    },
    contactDetails: {
      ContactDetails: 'Coordonnées',
      UpdateCardError: 'Échec de la mise à jour des informations de la carte',
      ExtendCardError: 'Échec de la prolongation de la date d\'expiration de la carte',
      DeleteCardError: 'Échec de la suppression de la carte',
      PayPalError: 'Échec de l\'ajout du compte PayPal',
      UpdateContactInfo: 'Mettre à jour vos informations de contact',
      PageLoadError: 'Erreur lors du chargement des coordonnées',
      SaveError: 'Erreur lors de la sauvegarde des informations de contact',
      SaveErrorGeneric: 'Une erreur inattendue s\'est produite lors de la sauvegarde de vos informations de contact. Veuillez réessayer.',
      SaveSuccess: 'Informations de contact sauvegardées avec succès',
      NetworkError: 'Erreur réseau. Veuillez vérifier votre connexion et réessayer.',
      ValidationError: 'Veuillez corriger les erreurs de validation et réessayer.',
      TryAgain: 'Réessayer',
      LoadingContactDetails: 'Chargement des coordonnées...',
      CancelButton: 'Annuler',
      SaveContactInfo: 'Enregistrer les informations de contact',
      Saving: 'Enregistrement...',
      AccountInfo: 'Informations du compte',
      Username: "Nom d'utilisateur",
      NameSection: 'Informations sur le nom',
      FirstName: 'Prénom',
      LastName: 'Nom',
      ContactInfo: 'Informations de contact',
      EmailAddress: 'Adresse e-mail',
      PrimaryPhone: 'Téléphone fixe',
      MobilePhone: 'Téléphone portable',
      PhonePlaceholder: 'Entrer le numéro de téléphone',
      FirstNameRequired: 'Le prénom est requis',
      LastNameRequired: 'Le nom est requis',
      EmailRequired: "L'adresse e-mail est requise",
      EmailInvalid: 'Veuillez entrer une adresse e-mail valide',
      PhoneInvalid: 'Veuillez entrer un numéro de téléphone valide',
      CardExtended: 'Date d\'expiration de la carte prolongée avec succès',
      CardDeleted: 'Carte supprimée avec succès',
      CardUpdated: 'Carte mise à jour avec succès',
      PayPalAdded: 'Compte PayPal ajouté avec succès',
    },
    banking: {
      // Page headers
      BankingDetails: 'Détails Bancaires',
      ManagePaymentAccounts: 'Gérez vos comptes de paiement pour les commandes et commissions',
      LoadingBankingDetails: 'Chargement des informations bancaires...',
      PageLoadError: 'Impossible de charger les informations bancaires. Veuillez réessayer.',

      // Current account section
      CurrentPaymentAccount: 'Compte de Paiement Actuel',
      UpdatePaymentAccount: 'Mettre à Jour le Compte de Paiement',
      AddPaymentAccount: 'Ajouter un Compte de Paiement',

      // Form fields
      BICCode: 'Code BIC (Code d\'Identification Bancaire)',
      BankName: 'Nom de la Banque',
      CurrentIBAN: 'IBAN Actuel',
      NewIBAN: 'Nouvel IBAN',
      DirectDebitAuthorization: 'J\'autorise les paiements par prélèvement automatique pour les commandes et commissions',
      MandateReference: 'Référence du Mandat',

      // Placeholders
      BICPlaceholder: 'ex., DEUTDEFF',
      AccountHolder: 'Titulaire du Compte',
      AccountHolderPlaceholder: 'ex., Jean Dupont',
      BankNamePlaceholder: 'ex., Deutsche Bank',
      BankNamePlaceholder2: 'Rempli automatiquement',
      IBANPlaceholder: 'ex., DE89370400440532013000',

      // Validation messages
      BICRequired: 'Le code BIC est requis',
      BICInvalidLength: 'Le BIC doit contenir 8-11 caractères',
      BICInvalidFormat: 'Format BIC invalide',
      InvalidBICCode: 'Code BIC invalide',
      BankNameRequired: 'Le nom de la banque est requis',
      AccountHolderRequired: 'Le titulaire du compte est requis',
      IBANRequired: 'L\'IBAN est requis',
      IBANInvalidLength: 'L\'IBAN doit contenir 15-34 caractères',
      IBANInvalidFormat: 'Format IBAN invalide',
      AuthorizationRequired: 'L\'autorisation de prélèvement automatique est requise',

      // Section titles
      ManagePayouts: 'Gérez vos paiements',
      ConsultantPaymentAccount: 'Votre compte de paiement consultant (OPA)',

      // Payout grid
      PayoutAccounts: 'Comptes de Paiement',
      PayoutType: 'Type de Paiement',
      Country: 'Pays',
      AccountNumber: 'Numéro de Compte',
      Deposit: 'Dépôt',
      NoPayoutAccounts: 'Aucun compte de paiement configuré',

      payoutType: {
        sepa: 'SEPA',
        bankTransfer: 'Virement bancaire',
      },

      // Modal
      AddAccount: 'Ajouter un Compte',
      AddNewAccount: 'Ajouter un Nouveau Compte',
      AccountType: 'Type de Compte',
      DirectDeposit: 'Dépôt Direct (Épargne)',
      Check: 'Chèque',
      DepositPercentage: 'Pourcentage de Dépôt',
      DepositPercentagePlaceholder: 'ex., 50',
      DepositPercentageInvalid: 'Le pourcentage de dépôt doit être entre 1 et 100',
      IBAN: 'IBAN',
      Save: 'Enregistrer',
      Cancel: 'Annuler',

      // Actions
      SaveNewAccount: 'Enregistrer le Nouveau Compte',
      RemoveAccount: 'Supprimer le Compte de Paiement',
      UpdatePayoutDistribution: 'Mettre à Jour la Distribution des Paiements',
      Saving: 'Enregistrement',
      Removing: 'Suppression',
      TryAgain: 'Réessayer',

      // Validation
      PercentageTotalMustBe100: 'Le pourcentage total doit être égal à 100%. Total actuel: {total}%',
      InvalidPayoutPercentage: 'Veuillez ajuster le pourcentage de paiement. Le pourcentage total entre tous les paiements actuellement actifs et futurs doit être de 100% par période.',

      // Success/Error messages
      SaveSuccess: 'Informations bancaires enregistrées avec succès',
      SaveError: 'Erreur lors de l\'enregistrement des informations bancaires',
      UnknownError: 'Une erreur inconnue s\'est produite',
      RemoveNotImplemented: 'La fonctionnalité de suppression n\'est pas encore implémentée',
      UpdateDistributionNotImplemented: 'La fonctionnalité de mise à jour de la distribution n\'est pas encore implémentée',

      // Delete confirmation
      DeleteAccount: 'Supprimer le Compte',
      DeleteAccountConfirmation: 'Êtes-vous sûr de vouloir supprimer ce compte de paiement?',
      DeleteAccountWarning: 'Cette action ne peut pas être annulée.',
      Delete: 'Supprimer',
      DeleteSuccess: 'Compte de paiement supprimé avec succès',
      DeleteError: 'Erreur lors de la suppression du compte de paiement'
    },
    reportDashboard: {
      defaultConsultantTitle: 'Executive Director',
      errors: {
        noPeriodDatesAvailable: 'Aucune période disponible',
        currentPeriodNotFound: 'Période actuelle introuvable',
      },
    },
    CongratulationsMessageStart: 'Félicitations ! Vous êtes payé en tant que ',
    CongratulationsMessageEnd: ' ce mois-ci.',
    ClassId: "ID de classe",
    editContact: {
      PageLoadError: 'Une erreur s\'est produite lors du chargement des détails du contact.',
      EditContact: 'Modifier le contact',
      EditContactDetails: 'Modifier les détails du contact ici',
      SaveButton: 'Enregistrer',
      CancelButton: 'Annuler',
      SelectTab: 'Sélectionner un onglet',
      SameAsBilling: 'Identique à l\'adresse de facturation',
      Name: 'Nom',
       Email: 'Adresse e-mail',
      PrimaryPhone: 'Numéro de téléphone principal',
      AltPhone: 'Numéro de téléphone alternatif',
      ShippingAddress: 'Adresse de livraison',
      BillingAddress: 'Adresse de facturation',
      SameAsShipping: 'Identique à l\'adresse de livraison',
      Communication: 'Communication',
      PhoneCountry: 'Pays',
      PhoneType: 'Type de téléphone',
      NoEmail: 'Aucune adresse e-mail disponible',
      OrderId: 'Numéro de commande',
      OrderTime: 'Date',
      OrderStatus: 'Statut',
      OrderTotal: 'Total',
      HostName: 'Nom de l\'hôte',
      EventDate: 'Date de l\'événement',
      ViewOrders: 'Voir les commandes',
      Order: 'Créer une commande',
      ClickViewOrders: 'Cliquez sur Voir les commandes pour charger la grille',
      OrderSummary: 'Résumé de la commande',
      PersonalInformation: 'Informations personnelles',
      Language: 'Langue',
      BirthDate: 'Date de naissance',
      Misc: 'Divers',
      Group: 'Groupe',
      HowDidYouHear: 'Comment avez-vous entendu parler de nous',
      AddNotes: 'Ajouter une note',
      SaveSuccess: 'Succès !',
      SaveError: 'Erreur',
      ContactUpdatedSuccessfully: 'Le contact a été mis à jour avec succès.',
      ContactUpdateFailed: 'Échec de la mise à jour du contact. Veuillez réessayer.',
      AdditionalInfoUpdatedSuccessfully: 'Les informations supplémentaires ont été mises à jour avec succès.',
      AdditionalInfoUpdateFailed: 'Échec de la mise à jour des informations supplémentaires. Veuillez réessayer.',
      SocialMediaUpdatedSuccessfully: 'Les informations sur les réseaux sociaux ont été mises à jour avec succès.',
      SocialMediaUpdateFailed: 'Échec de la mise à jour des informations sur les réseaux sociaux. Veuillez réessayer.',
      RequiredFieldsMissing: 'Veuillez remplir tous les champs obligatoires avant d\'enregistrer.',
      ShippingAddressFieldsRequired: 'Veuillez remplir tous les champs obligatoires de l\'adresse de livraison.',
      BillingAddressFieldsRequired: 'Veuillez remplir tous les champs obligatoires de l\'adresse de facturation.',
      PhoneRequired: 'Veuillez saisir un numéro de téléphone principal.',
      General: 'Général',
      Lead: 'Lead',
      Tasks: 'Tâches',
      Notes: 'Notes',
      Orders: 'Commandes',
      Activity: 'Activité',
      AdditionalInformation: 'Informations supplémentaires',
      SocialMedia: 'Réseaux sociaux',
    },
    leads: {
      NoLeads: 'Aucun lead trouvé pour ce contact.',
      LeadType: 'Type de lead',
      DistSource: 'Source de distribution',
      CreateDate: 'Date de création',
      AssignedDate: 'Date d\'attribution',
      FirstName: 'Prénom',
      LastName: 'Nom',
      Email: 'E-mail',
      Phone: 'Téléphone',
      Status: 'Statut',
      Source: 'Source',
      MyLeads: 'Mes Leads',
      AllLeads: 'Tous les Leads',
      leadCount: '{count} leads',
      LeadSubHeader: 'Gérez et suivez tous vos leads.',
      searchPlaceholder: 'Rechercher des leads...',
      Loading: 'Chargement...',
      Actions: 'Actions',
      Accept: 'Accepter',
      Reject: 'Rejeter',
      Refer: 'Référer',
      ReferTo: 'Référer à',
      SelectConsultant: 'Sélectionner un consultant',
      NoConsultantsFound: 'Aucun consultant trouvé',
      ConfirmAccept: 'Êtes-vous sûr de vouloir accepter ce lead ?',
      ConfirmReject: 'Êtes-vous sûr de vouloir rejeter ce lead ?',
      ConfirmRefer: 'Êtes-vous sûr de vouloir référer ce lead au consultant sélectionné ?',
      LeadAccepted: 'Lead accepté avec succès',
      LeadRejected: 'Lead rejeté avec succès',
      LeadReferred: 'Lead référé avec succès',
      Cancel: 'Annuler',
      Confirm: 'Confirmer',
      Accepted: 'Accepté',
      Closed: 'Fermé',
      Open: 'Ouvert'
    },
    contacts: {
      title: "Mes Contacts",
      allContacts: "Tous les contacts",
      contactCount: "{count} contacts",
      filters: "Filtres",
      filterTitle: "Filtrer les contacts",
      search: "Rechercher",
      searchPanelTitle: 'Recherche',
      clearSearch: "Effacer",
      searchOps: {
        all: "Tous",
        startsWith: "Commence par",
        endsWith: "Se termine par",
        contains: "Contient",
        notContains: "Ne contient pas",
        equals: "Égal à",
        notEqual: "Différent de"
      },
      classId: "ID de classe",
      group: "Groupe de contact",
      applyFilters: "Appliquer les filtres",
      clearFilters: "Effacer les filtres",
      filterSub: "Appliquer des filtres aux données du tableau",
      allClasses: "Toutes les classes",
      allGroups: "Tous les groupes",
      manageContacts: "Gérez tous vos contacts.",
      newContact: "Nouveau contact",
      noContactsFound: "Aucun contact trouvé",
      addSuccess: "Le contact a été ajouté avec succès !",
      updateSuccess: "Le contact a été mis à jour avec succès !",
      addedSuccessfully: "a été ajouté avec succès à vos contacts.",
      viewContact: "Cliquez ici pour voir le contact",
      deleteConfirm: "Êtes-vous sûr de vouloir supprimer {email} ?",
      sendEmail: "Envoyer un email",
      emailTo: "À : {email}",
      emailSubject: "Objet",
      emailMessage: "Message",
      cancel: "Annuler",
      send: "Envoyer",
      delete: "Supprimer",
      CCMyContacts: "Mes contacts CC",
      firstName: "Prénom",
      lastName: "Nom",
      email: "E-mail",
      phoneNumber: "Numéro de téléphone",
      actions: "Actions",
      edit: "Modifier",
    },
    addContact: {
      title: 'Ajouter un Contact',
      editTitle: 'Modifier le Contact',
      Communication: "Communication",
      firstName: 'Prénom',
      lastName: 'Nom',
      preferredName: 'Nom préféré',
      email: 'E-mail',
      noEmail: 'Aucune adresse e-mail disponible',
      phone: {
        primary: 'Téléphone principal',
        type: 'Type de téléphone',
        numberPlaceholder: 'Entrer le numéro de téléphone',
        alternative: ' Téléphone alternatif',
        cell: 'Mobile',
        work: 'Travail',
        home: 'Domicile',
        other: 'Autre',
      },
      address: {
        sameAsDelivery: 'Identique à l\'adresse de livraison',
        billing: 'Adresse de facturation'
      },
      requiredFieldsError: 'Veuillez remplir tous les champs obligatoires (Prénom, Nom, E-mail)',
      addressRequiredFieldsError: 'Veuillez remplir tous les champs d\'adresse requis (Ligne d\'adresse 1, Ville, Code postal, Pays, Nombre de Maison)',
      phoneRequiredError: 'Veuillez compléter tous les champs du téléphone principal (Pays, Numéro, Type)',
      save: 'Enregistrer',
      cancel: 'Annuler'
    },
    socialMedia: {
      placeholders: {
        facebook: 'https://facebook.com/username',
        instagram: 'https://instagram.com/username',
        pinterest: 'https://pinterest.com/username',
        youtube: 'https://youtube.com/channel/username',
        tiktok: "https://tiktok.com/{'@'}username",
      },
    },
    incentives: {
      SUPERSTARTERINCENTIVEPROGRESS:
      {
        1: 'Description de l\'incitation Super Starter - Niveau 1',
        2: 'Description de l\'incitation Super Starter - Niveau 2',
        3: 'Description de l\'incitation Super Starter - Niveau 3',
        4: 'Description de l\'incitation Super Starter - Niveau 4',
        programDetails: '<div><b>Détails du programme Super Starter</b><p>Complétez tous les niveaux pour gagner des récompenses exclusives et de la reconnaissance !</p></div>',
        completeMsg:
        {
          1: 'Félicitations ! Vous avez terminé le Niveau 1 !',
          2: 'Excellent travail ! Vous avez terminé le Niveau 2 !',
          3: 'Réalisation exceptionnelle ! Vous avez terminé le Niveau 3 !',
          4: 'Réalisation exceptionnelle ! Vous avez terminé le Niveau 4 !'
        }
      },
      TRIP2025INCENTIVEPROGRESS:
      {
        1: 'Description de l\'incitation au voyage 2025 - Argent',
        2: 'Description de l\'incitation au voyage 2025 - Or',
        3: 'Description de l\'incitation au voyage 2025 - Platine',
        programDetails: '<div><b>Fournir les détails du programme au format HTML</b></div>',
        completeMsg:
        {
          1: 'Vous avez gagné suffisamment de points pour passer au niveau suivant !',
          2: 'Vous avez gagné suffisamment de points pour passer au niveau suivant !',
          3: 'Vous avez gagné suffisamment de points pour passer au niveau suivant !'
        }
      },
      InqDsp_IncentiveCornerMSO:
      {
        1: 'Description de l\'offre de vente mensuelle - Niveau 1',
        2: 'Description de l\'offre de vente mensuelle - Niveau 2',
        3: 'Description de l\'offre de vente mensuelle - Niveau 3',
        programDetails: '<div><b>Fournir les détails du programme au format HTML</b></div>',
        completeMsg:
        {
          1: 'Vous avez gagné suffisamment de points pour passer au niveau suivant !',
          2: 'Vous avez gagné suffisamment de points pour passer au niveau suivant !',
          3: 'Vous avez gagné suffisamment de points pour passer au niveau suivant !'
        }
      },
      points: 'Points',
      travel: {
        title: 'Incitation au voyage',
        points: 'Points',
        programDetails: 'Détails du programme'
      },
      status: {
        inProgress: 'En cours',
        completed: 'Terminé'
      }
    },
    tabs: {
      TasksContent: 'Contenu des tâches à venir.',
      ActivityContent: 'Contenu des activités à venir.',
    },
    MyDocuments: 'Mes documents',
    CommissionStatements: 'Relevés de commissions',
    TaxDocuments: 'Documents fiscaux',
    SearchByDocumentTitle: 'Rechercher par titre de document',
    NoCommissionDocumentsFound: 'Aucun document de Relevés de Commissions ne correspond à vos critères de recherche.',
    NoTaxDocumentsFound: 'Aucun document fiscal ne correspond à vos critères de recherche.',
    DocumentUrlExpired: 'Le lien du document a expiré. Veuillez actualiser la page et réessayer.',
    Last3Months: 'Derniers 3 Mois',
    Last6Months: 'Derniers 6 Mois',
    Last12Months: 'Derniers 12 Mois',
    Last24Months: 'Derniers 24 Mois',
    AllTime: 'Tout le Temps',
    IncentiveTracker: 'Suivi des incitations',
    IncentiveTrackerDescription: 'Vérifiez vos incitations et leur progression.',
    LoadingIncentives: 'Chargement des incitations...',
    NoIncentivesFound: 'Aucune incitation trouvée.',
    IncentiveName: 'Nom de l\'incitation',
    OnTrack: 'En bonne voie',
    Step: 'Étape',
    Countdown: 'Compte à rebours',
    StartDate: 'Date de début',
    EndDate: 'Date de fin',
    Active: 'Actif',
    Closed: 'Fermé',
    Qualified: 'Qualifié',
    ReportDashboard: 'Équipe',
    CongratulationsMessage: 'Félicitations ! Vous êtes payé au titre de {title} ce mois-ci.',
    ThisMonth: 'Ce mois-ci',
    ThisYear: 'Cette année',
    PersonalTeamSales: 'Ventes de l\'équipe personnelle',
    OrganizationSales: 'Ventes de l\'organisation',
    TeamRecruits: 'Recrutements de l\'équipe',
    TeamEndCount: 'Effectif final de l\'équipe',
    GettingStarted: 'Pour commencer',
    MyPersonalTeam: 'Mon équipe personnelle',
    AllLevels: 'Tous les niveaux',
    AllStatus: 'Tous les statuts',
    Inactive: 'Inactif',
    NewConsultants: 'Nouveaux Consultants',
    SeniorConsultantsAndTeamLeaders: 'Consultants Senior et Chefs d"équipe',
    AtRisk: 'En risque',
    NotPaidAtTitle: 'Non payé au titre',
    CloseToLosingCareerSales: 'Proche de perdre les ventes de carrière',
    LessThan3PartiesBooked: 'Moins de 3 fêtes réservées le mois prochain',
    RoadToSuccess: 'Chemin vers le succès',
    CloseToPromoting: 'Proche de la promotion',
    CloseToEarningTravelIncentive: 'Proche de gagner un voyage prime',
    CloseToEarningSalesPromo: 'Proche de gagner une promotion des ventes',
    Leaderboard: 'Classement',
    Recruits: 'Recrutements',
    QualifiedRecruits: 'Recrutements qualifiés',
    CommissionableSales: 'Ventes commissionnables',
    GenerateRecognitionImage: 'Générer une image de reconnaissance',
    RecognitionCongratulations: 'FÉLICITATIONS!',
    RecognitionFirstPlace: 'Première place dans mon équipe!',
    RecognitionOutstanding: 'Performance exceptionnelle en {metric}!',
    Status: 'Statut',
    Title: 'Titre',
    PersonalSales: 'Ventes personnelles',
    ActiveConsultants: 'Consultants actifs',
    ViewAll: 'Voir tout',
    DaysLeft: 'Jours restants',
    Back: 'Retour',
    SelectSection: 'Sélectionner une section',
    Progress: 'Progression',
    TimeRemaining: 'Temps restant',
    CurrentLevel: 'Niveau actuel',
    RequirementProgress: 'Progression des exigences',
    vatLiability: {
      VATLiability: 'Responsabilité TVA',
      VATLiabilityDescription: 'Ajoutez votre ID TVA ou ID fiscal selon les conseils de votre conseiller fiscal',
      VATInformation: 'Informations TVA',
      VATIDType: 'Type d\'ID',
      VATID: 'ID TVA',
      TaxID: 'ID Fiscal',
      VATIDPlaceholder: 'Entrez votre ID TVA ou ID fiscal',
      LoadingVatInformation: 'Chargement des informations TVA...',
      SaveError: 'Erreur lors de la sauvegarde des informations TVA',
      SaveSuccess: 'Informations TVA sauvegardées avec succès',
      TryAgain: 'Réessayer',
      Save: 'Enregistrer',
      Saving: 'Enregistrement...',
      RequiredField: 'Ce champ est requis',
      InvalidVATFormat: 'Format TVA invalide. Utilisez DE + 9 chiffres ou ATU + 8 chiffres',
      InvalidVATFormatDE: 'Format TVA allemand invalide. Utilisez DE + 9 chiffres (ex., DE123456789)',
      InvalidVATFormatAT: 'Format TVA autrichien invalide. Utilisez ATU + 8 chiffres (ex., ATU12345678)',
      InvalidVATFormatFR: 'Format TVA français invalide. Utilisez FR + 2 lettres/chiffres + 9 chiffres (ex., FRXX123456789)',
      InvalidVATFormatUS: 'Format invalide. Utilisez 5-15 caractères alphanumériques',
      InvalidTaxIDFormat: 'L\'ID fiscal doit contenir au moins 5 caractères',
      InvalidTaxIDFormatUS: 'Format d\'ID fiscal américain invalide. Utilisez SSN (123-45-6789) ou EIN (12-3456789) ou 9 chiffres',
      InvalidTaxIDFormatDE: 'Format d\'ID fiscal allemand invalide. Utilisez 11 chiffres',
      InvalidTaxIDFormatFR: 'Format d\'ID fiscal français invalide. Utilisez 9 chiffres (SIREN)',
      InvalidTaxIDFormatAT: 'Format d\'ID fiscal autrichien invalide. Utilisez 9 chiffres',
      ValidFormat: 'Format valide détecté',
      UnknownError: 'Une erreur inconnue s\'est produite',
      VATCannotBeModified: 'Les informations TVA ne peuvent pas être modifiées une fois définies',
      TaxIdNoInputRequired: 'Aucune saisie requise pour TAXID'
    },
    myStory: {
      MyStoryHeader: 'Mon Histoire',
      MyStorySubHeader: 'Partagez votre histoire personnelle et votre site web avec les clients',
      LoadingStory: 'Chargement des informations de l\'histoire...',
      PageLoadError: 'Erreur lors du chargement de la page d\'histoire. Veuillez réessayer.',
      SaveError: 'Erreur lors de la sauvegarde de l\'histoire',
      SaveErrorGeneric: 'Une erreur inattendue s\'est produite lors de la sauvegarde de votre histoire. Veuillez réessayer.',
      SaveSuccess: 'Histoire sauvegardée avec succès !',
      NetworkError: 'Erreur réseau. Veuillez vérifier votre connexion et réessayer.',
      ValidationError: 'Veuillez corriger les erreurs de validation et réessayer.',
      TryAgain: 'Réessayer',
      SaveStory: 'Enregistrer l\'Histoire',
      Saving: 'Enregistrement...',
      PersonalStorySection: 'Histoire Personnelle',
      PersonalStory: 'Racontez Votre Histoire',
      StoryPlaceholder: 'Partagez votre histoire personnelle, votre parcours et ce qui vous rend unique en tant que consultant...',
      DesignMode: 'Design',
      HtmlMode: 'HTML',
      PreviewMode: 'Aperçu',
      HtmlPlaceholder: 'Entrez le code HTML ici...',
      WebsiteSection: 'Informations du Site Web',
      ConsultantWebsite: 'Site Web du Consultant',
      LinkToConsultantWeb: 'Lien vers le site web du consultant:',
      WebsitePlaceholder: 'https://votre-site-web.fr',
      InvalidURL: 'Veuillez entrer une URL valide (doit commencer par http:// ou https://)'
    },
    companyName: {
      CompanyName: 'Nom de l\'Entreprise',
      UpdateCompanyInfo: 'Mettez à jour le nom de votre entreprise et l\'URL du consultant',
      LoadingCompanyName: 'Chargement des informations de l\'entreprise...',
      PageLoadError: 'Erreur lors du chargement des informations de l\'entreprise',
      SaveError: 'Erreur lors de la sauvegarde des informations de l\'entreprise',
      SaveErrorGeneric: 'Une erreur inattendue s\'est produite lors de la sauvegarde des informations de votre entreprise. Veuillez réessayer.',
      SaveSuccess: 'Informations de l\'entreprise sauvegardées avec succès !',
      NetworkError: 'Erreur réseau. Veuillez vérifier votre connexion et réessayer.',
      ValidationError: 'Veuillez corriger les erreurs de validation et réessayer.',
      TryAgain: 'Réessayer',
      SaveCompanyName: 'Enregistrer le Nom de l\'Entreprise',
      Saving: 'Enregistrement...',
      BusinessNameSection: 'Informations de l\'Entreprise',
      BusinessName: 'Nom de l\'Entreprise',
      BusinessNamePlaceholder: 'Entrez le nom de votre entreprise',
      BusinessNameHelp: 'Ce nom sera utilisé dans votre URL de consultant et votre profil public.',
      BusinessNameRequired: 'Le nom de l\'entreprise est requis',
      BusinessNameTooShort: 'Le nom de l\'entreprise doit contenir au moins 2 caractères',
      BusinessNameTooLong: 'Le nom de l\'entreprise ne peut pas dépasser 100 caractères',
      BusinessNameInvalidCharacters: 'Le nom de l\'entreprise ne peut contenir que des lettres, des chiffres et des symboles standard',
      BusinessNameAlreadyExists: 'Ce nom d\'entreprise est déjà pris. Veuillez choisir un nom différent.',
      ConsultantUrlSection: 'URL du Consultant',
      ConsultantUrl: 'Votre URL de Consultant',
      UrlPlaceholder: 'nom-de-votre-entreprise',
      UrlHelp: 'C\'est l\'adresse web que les clients utiliseront pour trouver votre page de consultant.',
      SearchVisibilitySection: 'Visibilité dans les Recherches',
      OptOutFromSearch: 'Ne plus apparaître dans les résultats de recherche de consultants',
      OptOutHelp: 'Lorsque coché, votre profil n\'apparaîtra pas dans les résultats de recherche publique de consultants.',
      UpdateOptOut: 'Mettre à jour',
      Updating: 'Mise à jour...',
      OptOutUpdateSuccess: 'Paramètres de visibilité mis à jour avec succès !',
      OptOutUpdateError: 'Erreur lors de la mise à jour de la visibilité',
      OptOutUpdateErrorMessage: 'Une erreur s\'est produite lors de la mise à jour de vos paramètres de visibilité. Veuillez réessayer.',
      UnauthorizedError: 'Vous n\'êtes pas autorisé à effectuer cette action. Veuillez vous reconnecter.',
      TimeoutError: 'La demande a expiré. Veuillez réessayer.'
    },
    RecruitmentSearch: 'Recherche de Recrutement',
    RecruitmentSearchDescription: 'Contrôlez votre visibilité dans les recherches de recrutement de consultants',
    VisibilitySettings: 'Paramètres de Visibilité',
    ShowName: 'Afficher le Nom',
    ShowLocation: 'Afficher l\'Emplacement',
    ShowPhoto: 'Afficher la Photo',
    ShowEmail: 'Afficher l\'E-mail',
    ShowLandline: 'Afficher le Téléphone Fixe',
    ShowMobile: 'Afficher le Téléphone Portable',
    LoadingVisibilitySettings: 'Chargement des paramètres de visibilité...',
    LoadError: 'Erreur lors du chargement des paramètres',
    TryAgain: 'Réessayer',
    SaveError: 'Erreur lors de la sauvegarde des paramètres',
    Save: 'Enregistrer',
    Cancel: 'Annuler',
    ChangesSaved: 'Modifications enregistrées avec succès',
    ChangesDiscarded: 'Modifications annulées',
    FrenchContribution: 'Documents Fiscaux Français'
  },
  orderList: {
    AllOrderTypes: 'Tous les types de commandes',
    AllViews: 'Toutes les commandes',
    ApplyFilterButton: 'Appliquer le filtre',
    BetweenAnd: 'Et',
    ClearFilterButton: 'Effacer le filtre',
    searchPlaceholder: 'Rechercher des commandes...',
    orderCount: '{count} Commandes',
    CommissionableValue: 'CV',
    ColumnListHeader: 'Colonnes',
    ColumnListSubHeader: 'Activez et réorganisez les colonnes que vous souhaitez voir dans votre liste de commandes',
    ColumnOperandBeginsWith: 'Commence par',
    ColumnOperandBetween: 'Entre',
    ColumnOperandContains: 'Contient',
    ColumnOperandEquals: 'Égal à',
    ColumnOperandGreaterThan: 'Supérieur à',
    ColumnOperandGreaterThanOrEqual: 'Supérieur ou égal à',
    ColumnOperandLessThan: 'Inférieur à',
    ColumnOperandLessThanOrEqual: 'Inférieur ou égal à',
    ColumnOperandNotEquals: 'N\'est pas égal à',
    ColumnOperandSelectColumn: 'Sélectionner une colonne',
    CreateRMA: 'Créer un RMA',
    Email: 'E-mail',
    ExportButton: 'Exporter',
    ExportFileName: 'MesCommandes',
    FilterByColumn: 'Filtrer par valeur de colonne',
    FilterByOrderType: 'Filtrer par type de commande',
    FilterByView: 'Afficher',
    GridFilterHeader: 'Filtre',
    GridFilterSubHeader: 'Appliquer des filtres à votre liste de commandes',
    LastName: 'Nom',
    MakeReturn: 'Créer un retour',
    MasterOrderId: 'Référence de commande',
    NoColumnSelected: 'Sélectionner une colonne pour rechercher',
    NoTrackingNumber: 'Aucun numéro de suivi fourni',
    OrderDate: 'Date de commande',
    OrderId: 'Numéro de commande',
    Orders: 'Mes commandes',
     AllOrders: 'Toutes les commandes',
    OrderTotal: 'Total',
    OrderType: 'Type de commande',
    PaidView: 'Commandes payées',
    PlaceHolderSearchFilter: 'Rechercher',
    PlaceHolderSearchFilterDate: 'Rechercher une date',
    PlaceHolderSearchFilterNumber: 'Rechercher un numéro',
    PlaceHolderSearchFilterSecondDate: 'Rechercher une deuxième date',
    PlaceHolderSearchFilterSecondNumber: 'Rechercher un deuxième numéro',
    OrderSubHeader: 'Suivez toutes vos commandes.',
    TrackingNumber: 'Numéro de suivi',
    UnpaidView: 'Commandes non payées',
    ViewInvoice: 'Voir la facture',
    Page: 'Page',
    Of: 'sur',
    Previous: 'Précédent',
    Next: 'Suivant',
    address: {
      // Page headers
      AddressManagement: 'Gestion des adresses',
      ManageAddresses: 'Gérez vos adresses de facturation, de livraison et postales',
      LoadingAddresses: 'Chargement des informations d\'adresse...',
      PageLoadError: 'Impossible de charger les informations d\'adresse. Veuillez réessayer.',

      // Address types
      BillingAddress: 'Adresse de facturation',
      DeliveryAddress: 'Adresse de livraison',
      MailingAddress: 'Adresse postale',

      // Actions
      AddNew: 'Ajouter nouvelle',
      Change: 'Modifier',
      UseExisting: 'Utiliser existante',
      Save: 'Enregistrer',
      Saving: 'Enregistrement...',
      Cancel: 'Annuler',
      TryAgain: 'Réessayer',

      // Form labels
      ContactInfo: 'Informations de contact',
      AddressDetails: 'Détails de l\'adresse',
      FirstName: 'Prénom',
      LastName: 'Nom',
      AddressLine1: 'Ligne d\'adresse 1',
      AddressLine2: 'Ligne d\'adresse 2 (Optionnel)',
      City: 'Ville',
      StateCode: 'État/Province',
      PostalCode: 'Code postal',
      CountryCode: 'Pays',

      // Form titles
      AddNewAddress: 'Ajouter une nouvelle adresse',
      EditAddress: 'Modifier l\'adresse',
      SelectExistingAddress: 'Sélectionner une adresse existante',

      // Status messages
      NoAddressSet: 'Aucune adresse définie',
      NoSavedAddresses: 'Aucune adresse sauvegardée disponible',

      // Validation messages
      FirstNameRequired: 'Le prénom est requis',
      LastNameRequired: 'Le nom est requis',
      AddressLine1Required: 'La ligne d\'adresse 1 est requise',
      CityRequired: 'La ville est requise',
      StateCodeRequired: 'L\'état/province est requis',
      PostalCodeRequired: 'Le code postal est requis',
      CountryCodeRequired: 'Le pays est requis',
      ValidationError: 'Veuillez corriger les erreurs de validation et réessayer',

      // Success/Error messages
      SaveSuccess: 'Informations d\'adresse sauvegardées avec succès !',
      SaveError: 'Erreur lors de la sauvegarde des informations d\'adresse',
      SaveErrorGeneric: 'Une erreur s\'est produite lors de la sauvegarde. Veuillez réessayer.',
      NetworkError: 'Erreur réseau. Veuillez vérifier votre connexion et réessayer.'
    },
    contracts: {
      title: 'Contrats',
      description: 'Voir une liste des contrats que vous avez signés',
      name: 'Nom',
      version: 'Version',
      deliveredOn: 'Livré Le',
      signByDate: 'Date Limite de Signature',
      loading: 'Chargement des contrats...',
      noContracts: 'Aucun Contrat Trouvé',
      noContractsDescription: 'Vous n\'avez encore signé aucun contrat.'
    }
  },
  webshopSettings: {
      // Page headers
      WebshopSettings: 'Paramètres de Boutique Web',
      ManageWebshopSettings: 'Permet aux consultants de gérer les paramètres de boutique web, les méthodes de paiement et les renouvellements',
      LoadingWebshopSettings: 'Chargement des paramètres de boutique web...',
      PageLoadError: 'Impossible de charger les paramètres de boutique web. Veuillez réessayer.',

      // Plan Selection
      chooseYourPlan: 'Choisissez Votre Plan',
      manageYourPlan: 'Gérez Votre Plan',
      activeSubscription: 'Abonnement Actif',
      start90DaysTrial: 'Commencez votre essai gratuit de 90 jours aujourd\'hui',
      startFreeTrial: 'Commencer l\'Essai Gratuit',
      trialPeriod: 'Période d\'Essai',
      noPlanSelected: 'Aucun Plan Sélectionné',
      noPlanSelectedMessage: 'Cliquez sur un plan ci-dessous pour le sélectionner pour la fin de votre période d\'essai.',
      noPlanSelectedAssuranceMessage: 'Vous ne serez pas facturé(e) ni inscrit(e) automatiquement tant que vous n\'aurez pas sélectionné un plan.',
      trialActiveMessage: 'Vous êtes actuellement actif dans le programme d\'essai.',
      trialPlanSelectionNearEndMessage: 'Vous pourrez choisir votre plan à partir de 10 jours avant la fin de votre période d\'essai ({countdown}). Vous ne serez pas facturé(e) ni inscrit(e) automatiquement tant que vous n\'aurez pas sélectionné un plan.',
      countdownInOneWeek: 'dans 1 semaine',
      countdownInWeeks: 'dans {count} semaines',
      countdownInOneDay: 'dans 1 jour',
      countdownInDays: 'dans {count} jours',
      currentSelection: 'Sélection Actuelle',
      plan: 'Plan',
      trialSelectionMessage: 'Vous pouvez changer votre plan ou vous désinscrire à tout moment avant la fin de votre essai. Votre carte ne sera pas débitée si aucun plan n\'est sélectionné.',
      trialEndsOn: 'Votre période d\'essai se termine le',
      continueToPurchase: 'Continuer vers l\'Achat',
      currentPaymentMethod: 'Méthode de Paiement Actuelle',
      manageBilling: 'Gérer la Facturation',
      selectPaymentMethod: 'Sélectionner le Mode de Paiement',
      addNewCard: 'Ajouter une Nouvelle Carte',
      processingCard: 'Traitement de la carte...',
      cancel: 'Annuler',
      select: 'Sélectionner',
      current: 'Actuel',
      pending: 'En attente',
      monthly: 'Mensuel',
      quarterly: 'Trimestriel',
      biAnnual: 'Semestriel',
      annual: 'Annuel',
      savePercent: 'Économisez {savings}%',
      visa: 'VISA',
      expires: 'Expire',
      processing: 'Traitement...',
      selectAPlan: 'Sélectionnez un plan',
      confirmPlanSelection: 'Confirmer la Sélection du Plan',
      confirmPlanMessage: 'Êtes-vous sûr de vouloir sélectionner ce plan? Ce sera votre plan de renouvellement à la fin de votre essai.',
      confirm: 'Confirmer',
      pendingChange: 'Changement en Attente',
      pendingChangeMessage: 'Vous pouvez changer votre plan à tout moment. Les modifications prendront effet le {renewalDate}.',
      currentPlan: 'Plan Actuel',
      month: 'mois',
      sixMonths: '6 mois',
      year: 'an',
      frequency: {
        perMonth: 'par mois',
        everyThreeMonths: 'tous les 3 mois',
        everySixMonths: 'tous les 6 mois',
        perYear: 'par an',
      },
      planChangeMessage: 'Vous pouvez changer votre plan à tout moment. Les modifications prendront effet lors de votre prochain cycle de facturation.',
      upgradeMessage: 'Vous pouvez passer à un plan différent à tout moment. Les modifications prendront effet lors de votre prochain cycle de facturation.',
      subscriptionActive: 'Votre abonnement est actif',
      subscriptionEndsOn: 'Votre abonnement se terminera le : {renewalDate}',
      nextBilling: 'Prochaine facturation',
      cancelPendingChange: 'Annuler le Changement en Attente',
      cancelPendingChangeTitle: 'Annuler le Changement en Attente',
      cancelPendingChangeMessage: 'Êtes-vous sûr de vouloir annuler votre changement de plan en attente? Votre plan actuel restera actif.',
      confirmCancel: 'Confirmer l\'Annulation',
      cancelSubscription: 'Annuler l\'Abonnement',
      cancelSubscriptionTitle: 'Annuler l\'Abonnement',
      cancelSubscriptionMessage: 'Votre abonnement ne sera pas renouvelé après la date de renouvellement. Êtes-vous sûr de vouloir annuler?',
      confirmCancelSubscription: 'Confirmer l\'Annulation',
      subscriptionCancelledMessage: 'Vous avez annulé votre abonnement. Votre abonnement ne sera pas renouvelé après la date de renouvellement. Vous pourrez vous réinscrire après la fin de votre abonnement actuel.',
      deleteCardTitle: 'Supprimer la Carte',
      deleteCardMessage: 'Êtes-vous sûr de vouloir supprimer cette carte ? Cette action ne peut pas être annulée.',
      confirmDeleteCard: 'Supprimer la Carte',

      // Expired/No Active Subscription State
      noActiveSubscription: 'Aucun Abonnement Actif',
      noCurrentSubscription: 'Aucun Abonnement Actuel',
      noCurrentSubscriptionMessage: 'Sélectionnez un plan ci-dessous pour commencer. Vous pouvez modifier ou annuler à tout moment.',
      invalidPaymentMethod: 'Moyen de paiement invalide',
      invalidPaymentMethodMessage: 'Ajoutez ou modifiez votre moyen de paiement.',
      paymentDue: 'Paiement dû',
      renewalProcessingTitle: 'Renouvellement en Cours',
      renewalProcessingMessage: 'Votre changement de renouvellement est en cours de traitement. Veuillez patienter pendant que cette mise à jour est terminée.',
      renewalProcessingPendingLabel: 'Votre renouvellement est en cours de traitement. Les actions de plan et de facturation sont temporairement indisponibles.',
      getStartedToday: 'Commencez aujourd\'hui',
      choosePlanToBegin: 'Choisissez un plan pour commencer votre abonnement',
      paymentSetupRequired: 'Configuration de Paiement Requise',
      paymentSetupMessage: 'Vous serez invité à ajouter un moyen de paiement après avoir sélectionné votre plan. Aucun frais jusqu\'à confirmation.',
      reenroll: 'Se Réinscrire',

      // Actions
      ChangePlan: 'Changer de Plan',
      Enroll: 'S\'Inscrire',
      RenewEnrollment: 'Renouveler l\'Inscription',
      Reenroll: 'Se Réinscrire',
      TerminateOnlineShop: 'Terminer la Boutique En Ligne',
      Unenroll: 'Se Désinscrire',
      UpdatePendingChanges: 'Mettre à Jour les Changements en Attente',
      RevertPendingChanges: 'Annuler les Changements en Attente',
      TryAgain: 'Réessayer',

      // Current Plan Section
      CurrentPlan: 'Informations du Plan Actuel',
      PlanName: 'Nom du Plan',
      RenewalFrequency: 'Fréquence de Renouvellement',
      ProcessStatus: 'Statut du Processus',
      NextRenewalDate: 'Prochaine Date de Renouvellement',

      // Current Configuration Section
      CurrentConfiguration: 'Configuration Actuelle',
      CurrentProgramName: 'Nom du Programme Actuel',
      CurrentOptionalPrograms: 'Programmes Optionnels Actuels',
      RenewalDate: 'Date de Renouvellement',
      ExpiresOn: 'Expire Le',

      // Current Program Section (legacy)
      CurrentProgram: 'Informations du Programme Actuel',
      RequiredProgram: 'Programme Requis',
      OptionalPrograms: 'Programmes Optionnels',
      NoOptionalPrograms: 'Aucun programme optionnel',

      // Pending Changes Section
      PendingChanges: 'Changements en Attente',
      Current: 'Configuration Actuelle',
      Pending: 'Configuration en Attente',
      PendingConfiguration: 'Configuration en Attente',
      Program: 'Programme',
      PeriodName: 'Nom de la Période',
      FuturePeriodName: 'Nom de la Période Future',
      FutureProgramName: 'Nom du Programme Futur',
      FutureOptionalPrograms: 'Programmes Optionnels Futurs',
      EffectiveDate: 'Date d\'Entrée en Vigueur',

      // Next Payment Section
      NextPayment: 'Prochain Paiement',
      RenewalOverdue: 'Renouvellement en Retard',
      AccountOverdueMessage: 'Votre renouvellement de compte est en retard. Veuillez mettre à jour vos informations de paiement.',
      CardWillBeCharged: 'Votre carte sera débitée',

      // Payment Information Section (legacy)
      PaymentInformation: 'Informations de Paiement',
      NextChargeAmount: 'Montant du Prochain Prélèvement',
      NextChargeDate: 'Date du Prochain Prélèvement',

      // Secondary Plan Section
      SecondaryPlan: 'Informations du Plan Secondaire',
      SecondaryPlanName: 'Nom du Plan Secondaire',
      SecondaryStatus: 'Statut Secondaire',
      SecondaryRenewalDate: 'Date de Renouvellement Secondaire',
      SecondaryRenewalConfigurationPending: 'Le statut de configuration de renouvellement est en attente',

      // Configuration Status Messages
      RenewalConfigurationPending: 'Configuration de Renouvellement en Attente',
      RenewalConfigurationPendingMessage: 'Votre configuration de renouvellement est actuellement en cours de traitement. Veuillez revérifier plus tard.',
      NoActivePlan: 'Aucun Plan Actif',
      NoActivePlanMessage: 'Vous n\'\u00eates actuellement inscrit à aucun plan. Cliquez sur "Se Réinscrire" pour rejoindre un programme de renouvellement.',

      // Status values
      StatusActive: 'Actif',
      StatusPending: 'En Attente',
      StatusExpired: 'Expiré',
      StatusCancelled: 'Annulé',
      StatusProcessing: 'En Cours de Traitement',

      // Success/Error messages
      SaveSuccess: 'Paramètres de boutique web mis à jour avec succès !',
      SaveError: 'Erreur lors de la mise à jour des paramètres de boutique web',
      SaveErrorGeneric: 'Une erreur s\'est produite lors de la mise à jour. Veuillez réessayer.',
      NetworkError: 'Erreur réseau. Veuillez vérifier votre connexion et réessayer.',

      // Change Plan Modal
      ChangePlanModalTitle: 'Changer de Plan',
      ChangePlanModalDescription: 'Sélectionnez une nouvelle fréquence de renouvellement et des programmes pour votre plan',
      SelectRenewalFrequency: 'Sélectionner la Fréquence de Renouvellement',
      RenewalFrequencyPlaceholder: 'Choisir la fréquence de renouvellement...',
      LoadingRenewalFrequencies: 'Chargement des fréquences de renouvellement...',
      NoRenewalFrequenciesAvailable: 'Aucune fréquence de renouvellement disponible',
      RequiredPrograms: 'Programmes Requis',
      OptionalProgramsSelection: 'Programmes Optionnels',
      LoadingPrograms: 'Chargement des programmes...',
      NoProgramsAvailable: 'Aucun programme disponible',
      Kits: 'Kits',
      LoadingKits: 'Chargement des kits...',
      NoKitsAvailable: 'Aucun kit disponible pour les programmes sélectionnés',
      SelectProgram: 'Veuillez sélectionner un programme pour voir les kits disponibles',
      Cancel: 'Annuler',
      SaveChanges: 'Enregistrer les Modifications',
      ChangePlanSuccess: 'Plan changé avec succès !',
      ChangePlanError: 'Erreur lors du changement de plan',

      // Revert Confirmation Modal
      ConfirmRevert: 'Confirmer l\'Annulation des Modifications',
      ConfirmRevertMessage: 'Êtes-vous sûr de vouloir annuler les modifications en attente ? Cette action ne peut pas être annulée.',
      ConfirmRevertButton: 'Oui, Annuler les Modifications',

      // Select Payment Method Modal
      SelectPaymentMethod: 'Sélectionner le Mode de Paiement',
      SelectPaymentDescription: 'Choisissez le mode de paiement que vous souhaitez utiliser pour les paiements de renouvellement',
      LoadingPaymentMethods: 'Chargement des modes de paiement...',
      NoPaymentMethodsAvailable: 'Aucun mode de paiement disponible. Veuillez d\'abord ajouter un mode de paiement.',
      CurrentRenewalCard: 'Renouvellement Actuel',
      CardNumber: 'Numéro de Carte',
      ExpirationDate: 'Date d\'Expiration',
      HolderName: 'Nom du Titulaire',
      ConfirmSelection: 'Confirmer la Sélection',

      // Renewal Countdown Notification
      RenewalReminder: 'Rappel de Renouvellement',
      RenewalReminderMessage: 'Votre renouvellement arrive dans {days} jours!'
  },
  dashboard: {
    progress: {
      MyProgress: 'Mon Progrès',
      Progress: 'Progrès',
      ProgressInfo: 'Aperçu des indicateurs de performance.',
      MonthlyOverview: 'Ce Mois',
      Overview: 'Aperçu',
      MonthlyProgressInfo: 'Aperçu des performances de ce mois.',
      TotalRecruitmentCount: 'Nombre Total de Recrutements',
      CareerSales: 'Ventes de Carrière',
      UnsubmittedPartyOrder: 'Commandes de Fête Non Soumises',
      NextPromotionLevel: 'Prochain Niveau de Promotion',
      NextPromotionProgress: 'Il vous reste {0} avant votre prochain niveau de promotion !',
      PROMOTIONPROGRESS_PSV: 'Volume de Ventes Personnel',
      PROMOTIONPROGRESS_PSV_MESSAGE: 'Il vous reste {0} pour atteindre le prochain niveau !',
      PROMOTIONPROGRESS_ACTIVELINES: 'Lignes Actives',
      PROMOTIONPROGRESS_ACTIVELINES_MESSAGE: 'Vous avez besoin de {0} lignes actives supplémentaires pour atteindre le prochain niveau !',
      PROMOTIONPROGRESS_TEAMSALES: 'Ventes d\'Équipe',
      PROMOTIONPROGRESS_TEAMSALES_MESSAGE: 'Votre équipe a besoin de {0} de ventes supplémentaires pour progresser !',
      PROMOTIONPROGRESS_GEN1DIRECTORS: 'Directeurs Gen 1',
      PROMOTIONPROGRESS_GEN1DIRECTORS_MESSAGE: 'Vous avez besoin de {0} Directeurs Gen 1 supplémentaires pour atteindre le prochain niveau !',
      PROMOTIONPROGRESS_EXECDIRECTORTEAMS: 'Équipes de Directeurs Exécutifs',
      PROMOTIONPROGRESS_EXECDIRECTORTEAMS_MESSAGE: 'Vous avez besoin de {0} Équipes de Directeurs Exécutifs supplémentaires pour progresser !',
      PROMOTIONPROGRESS_ORGVOLUME: 'Volume d\'Organisation',
      PROMOTIONPROGRESS_ORGVOLUME_MESSAGE: 'Votre organisation a besoin de {0} de volume supplémentaire pour atteindre le prochain niveau !',
      RequirementCompleted: 'Exigence complétée ! Félicitations !',
      MonthlyRecruitmentCount: 'Nombre de Recrutements',
      MonthlySales: 'Revenu Mensuel',
      MonthlyQV: 'Volume Qualifiant Mensuel',
      CommissionRate: 'Taux de Commission',
      QV: 'PQP'
    },
    invoice: {
      orderNumber: 'Numéro de commande',
      eventId: 'ID d\'\u00e9vénement',
      customerName: 'Nom du client',
      invoiceNumber: 'Numéro de facture',
      amount: 'Montant',
      status: 'Statut de la facture',
      issueDate: 'Date d\'\u00e9mission',
      reads: 'Lectures',
      hints: 'Conseils',
      title: 'Commandes ouvertes',
      description: 'Suivez les factures ouvertes, annulez ou renvoyez des factures si nécessaire.',
      allInvoices: 'Toutes les factures',
      read: 'Lu',
      sent: 'Envoyé',
      Issued: 'Émis',
      NotPaid: 'Non payé',
      Paid: 'Payé',
      GridFilterHeader: 'Filtrer les factures',
      GridFilterSubHeader: 'Utilisez les options ci-dessous pour filtrer la liste des factures',
      FilterByStatus: 'Filtrer par statut',
      FilterByPeriod: 'Filtrer par période',
      AllStatuses: 'Tous les statuts',
      AllPeriods: 'Toutes les périodes',
      Last30Days: 'Derniers 30 jours',
      Last60Days: 'Derniers 60 jours',
      Last90Days: 'Derniers 90 jours',
      CancelInvoice: 'Annuler la facture',
      ResendInvoice: 'Renvoyer la facture',
      ActionsUnavailableCanceled: 'Cette facture a été annulée',
      ActionsUnavailablePaid: 'Cette facture a été payée',
      Resend: 'Renvoyer',
      orders: 'commandes',
      noInvoicesFound: 'Aucune facture trouvée pour les critères sélectionnés.',
      Cancelled: 'Annulé',
      Read: 'Lu'
    },
    openParties: {
      title: 'Fêtes Ouvertes',
      description: 'Gérez vos fêtes et événements à venir.',
      parties: 'fêtes',
      CreateParty: 'Créer une Fête',
      DaysTilParty: 'Jours jusqu\'\u00e0 la Fête',
      NumberOfCarts: 'Nombre de Paniers',
      ExternalOrders: 'Commandes Externes',
      day: 'jour',
      days: 'jours'
    },
    incentives: {
      SUPERSTARTERINCENTIVEPROGRESS:
      {
        1: 'Description de l\'Incitatif Super Starter - Niveau 1',
        2: 'Description de l\'Incitatif Super Starter - Niveau 2',
        3: 'Description de l\'Incitatif Super Starter - Niveau 3',
        4: 'Description de l\'Incitatif Super Starter - Niveau 4',
        programDetails: '<div><b>Détails du Programme Super Starter</b><p>Complétez tous les niveaux pour gagner des récompenses exclusives et de la reconnaissance !</p></div>',
        completeMsg:
        {
          1: 'Félicitations ! Vous avez terminé le Niveau 1 !',
          2: 'Excellent travail ! Vous avez terminé le Niveau 2 !',
          3: 'Réalisation exceptionnelle ! Vous avez terminé le Niveau 3 !',
          4: 'Réalisation exceptionnelle ! Vous avez terminé le Niveau 4 !'
        }
      },
      TRIP2025INCENTIVEPROGRESS:
      {
        1: 'Description de l\'Incitatif Voyage 2025 - Argent',
        2: 'Description de l\'Incitatif Voyage 2025 - Or',
        3: 'Description de l\'Incitatif Voyage 2025 - Platine',
        programDetails: '<div><b>Fournir les détails du programme au format HTML</b></div>',
        completeMsg:
        {
          1: 'Vous avez gagné assez de points pour passer au niveau suivant !',
          2: 'Vous avez gagné assez de points pour passer au niveau suivant !',
          3: 'Vous avez gagné assez de points pour passer au niveau suivant !'
        }
      },
      InqDsp_IncentiveCornerMSO:
      {
        1: 'Description de l\'Offre de Ventes Mensuelles - Niveau 1',
        2: 'Description de l\'Offre de Ventes Mensuelles - Niveau 2',
        3: 'Description de l\'Offre de Ventes Mensuelles - Niveau 3',
        programDetails: '<div><b>Fournir les détails du programme au format HTML</b></div>',
        completeMsg:
        {
          1: 'Vous avez gagné assez de points pour passer au niveau suivant !',
          2: 'Vous avez gagné assez de points pour passer au niveau suivant !',
          3: 'Vous avez gagné assez de points pour passer au niveau suivant !'
        }
      },
      points: 'Points',
      travel: {
        title: 'Incitatif Voyage',
        points: 'Points',
        programDetails: 'Détails du Programme'
      },
      status: {
        inProgress: 'En Cours',
        completed: 'Terminé'
      }
    }
  },
  richTextEditor: {
    designMode: 'Design',
    htmlMode: 'HTML',
    previewMode: 'Aperçu',
    normalText: 'Texte Normal',
    heading1: 'Titre 1',
    heading2: 'Titre 2',
    heading3: 'Titre 3',
    paragraph: 'Paragraphe',
    textColor: 'Couleur du Texte',
    backgroundColor: 'Couleur d\'Arrière-plan',
    createLink: 'Créer un Lien',
    removeLink: 'Supprimer le Lien',
    enterUrl: 'Entrez l\'URL :',
    htmlPlaceholder: 'Entrez le code HTML ici...'
  },
  account: {
    ChooseOption: 'Choisissez Votre Option',
    ChooseDescription: 'Avez-vous déjà un compte chez nous ?',
    HaveAccount: 'Oui, j\'ai un compte',
    CreateAtCheckout: 'Non, j\'en créerai un lors du paiement'
  },
  kit: {
    miniHeader: 'Ici, tu trouveras tout ce dont tu as besoin pour bien démarrer.',
    kitHeader: 'Choisissez un ensemble comprenant nos produits les plus populaires.',
    startForFree: 'Tu souhaites commencer sans kit de démarrage ? Merci de contacter le service clientèle.',
    contactLabel: 'Contacter :',
    details: 'Contenu du kit',
    productsInKit: 'Produits dans ce Kit:',
    startUpBox: 'Boîte de Démarrage:',
    totalValue: '({0} valeur totale!)',
    selectKitTitle: 'Sélectionnez Votre Kit',
    selectKitMessage: 'Plusieurs kits sont disponibles pour votre pays. Veuillez sélectionner le kit que vous souhaitez acheter :',
    selectKit: 'Sélectionner Ce Kit',
    noProductsAvailable: 'Aucun produit kit n\'est disponible pour le pays sélectionné. Veuillez contacter le service client pour obtenir de l\'aide.'
  },
  frenchContribution: {
    FrenchContributionHeader: 'Documents Fiscaux Français',
    FrenchContributionSubHeader: 'Téléchargez vos documents fiscaux pour examen et approbation de conformité',
    SiretNumber: 'Numéro SIRET',
    UploadFile: 'Cliquez pour télécharger ou glissez-déposez votre document fiscal',
    MaxFileSize: 'Taille maximale du fichier : 10MB',
    SupportedFormats: 'Format supporté : PDF uniquement',
    SelectedFile: 'Fichier Sélectionné',
    RemoveFile: 'Supprimer le Fichier',
    Upload: 'Télécharger le Document',
    Uploading: 'Téléchargement...',
    LoadingDocuments: 'Chargement des documents...',
    PageLoadError: 'Erreur lors du chargement de la section contribution française',
    SaveError: 'Échec du Téléchargement',
    SaveSuccess: 'Document téléchargé avec succès ! Votre document fiscal a été soumis pour examen.',
    TryAgain: 'Réessayer',
    FileTooLarge: 'La taille du fichier dépasse la limite de 10MB. Veuillez choisir un fichier plus petit.',
    InvalidFileFormat: 'Seuls les fichiers PDF sont supportés. Veuillez sélectionner un document PDF.',
    UnknownError: 'Une erreur inattendue s\'est produite. Veuillez réessayer.'
  },
  eventTasks: {
    title: 'Tâches d\'événement',
    subtitle: 'Prospects acceptés',
    loading: 'Chargement des prospects...',
    noLeads: 'Aucun prospect accepté trouvé.',
    email: 'E-mail',
    phone: 'Téléphone',
    leadType: 'Type de prospect',
    source: 'Source',
    note: 'Note',
    loadingNote: 'Chargement de la note...',
    notePlaceholder: 'Ajouter une note sur ce prospect...',
    saveNote: 'Enregistrer la note',
    created: 'Créé',
    assigned: 'Assigné',
    accepted: 'Accepté',
    partyDate: 'Date de la fête',
    theme: 'Thème',
    bestTime: 'Meilleur moment pour contacter',
    tasks: 'Tâches',
    due: 'Échéance',
    registerNewMember: 'Inscrire un nouveau membre',
    joinMyTeam: 'Rejoindre mon équipe',
    saveTasks: 'Enregistrer les tâches',
    joinMyTeamUrlCopied: 'URL « Rejoindre mon équipe » copiée dans le presse-papiers !',
    failedToCopyUrl: 'Impossible de copier l\'URL. Veuillez réessayer.',
    failedToLoadLeads: 'Impossible de charger les prospects. Veuillez réessayer.',
    failedToSaveTasks: 'Impossible d\'enregistrer les tâches. Veuillez réessayer.',
    failedToSaveNote: 'Impossible d\'enregistrer la note. Veuillez réessayer.',
    tasksSavedSuccessfullyFor: 'Tâches enregistrées avec succès pour {firstName} {lastName}',
    noteSavedSuccessfullyFor: 'Note enregistrée avec succès pour {firstName} {lastName}',
    errorLoadingNote: 'Impossible de charger la note. Veuillez réessayer.',
    coaching: {
      contact: 'Parlez des avantages de cette belle opportunité et partagez votre histoire personnelle sur la façon dont TPC a enrichi votre vie.',
      email: 'Copiez-collez le lien suivant dans un e-mail et envoyez-le à votre recrue\n{fullUrl}\nIndiquez-lui de saisir votre identifiant consultant lorsqu\'il/elle y sera invité(e) pendant le processus d\'inscription.',
      followup: 'Appelez le/la prospect(e) pour vous assurer qu\'il/elle a bien reçu le contrat et répondre à ses questions.',
    },
    taskNames: {
      contact: 'Contacter un(e) consultant(e) potentiel(le)',
      email: 'Envoyer par e-mail le lien d\'inscription à un(e) consultant(e) potentiel(le)',
      followup: 'Appel de suivi avec un(e) consultant(e) potentiel(le)',
    },
  },
  businessDetails: {
    Title: 'Détails de l\'entreprise',
    ShowChart: 'Afficher le graphique',
    ShowGrid: 'Afficher la grille',
    Metrics: 'Métriques',
    ChartTitle: 'Métriques commerciales au fil du temps',
    errors: {
      noColumnsFoundInReportDefinition: 'Aucune colonne trouvée dans la définition du rapport',
      noBatchHistoryFound: 'Aucun historique de lots trouvé',
      failedToLoadData: 'Impossible de charger les données',
    },
  },
  teamIncentiveDetails: {
    Title: 'Détails des incitatifs d\'équipe',
    NoReportsFound: 'Aucun rapport d\'incitatif trouvé',
    SelectIncentive: 'Incitatif',
    SelectPlaceholder: 'Sélectionnez un rapport d\'incitatif...'
  },
  consultantActivity: {
    Title: 'Activité du consultant',
    SelectBatch: 'Sélectionner la période de lot',
    SelectBatchPlaceholder: 'Sélectionnez un lot...',
    SelectedBatchInfo: 'Informations sur le lot sélectionné',
    BatchName: 'Nom du lot',
    BatchNumber: 'Numéro de lot',
    HistoryDate: 'Date d\'historique',
    NoDataAvailable: 'Aucune donnée disponible pour le lot sélectionné',
    AdjustmentsTab: 'Ajustements',
    ActivityTab: 'Activité',
    OrdersTab: 'Commandes',
    ActivityTabPlaceholder: 'Le rapport d\'activité sera affiché ici. Mise en œuvre à venir.',
    OrdersTabPlaceholder: 'Le rapport de commandes sera affiché ici. Mise en œuvre à venir.',
    Metric: 'Métrique',
    Value: 'Valeur',
    IncludeTeam: 'Inclure l\'équipe',
    RemoveTeam: 'Retirer l\'équipe'
  },
  ccReport: {
    Filters: 'Filtres',
    ApplyFiltersToTableData: 'Appliquer des filtres aux données du tableau',
    NoFilterableColumns: 'Aucune colonne filtrable disponible pour ce rapport.',
    StartDate: 'Date de début',
    EndDate: 'Date de fin',
    ClearFilters: 'Effacer les filtres',
    ApplyFilters: 'Appliquer les filtres',
    IncludeTeam: 'Inclure l\'équipe',
    RemoveTeam: 'Retirer l\'équipe',
    ShowingItems: '{0} - {1} sur {2} éléments',
    NoRecordsAvailable: 'Aucun enregistrement disponible',
    ExpandAll: 'Tout développer',
    CollapseAll: 'Tout réduire',
    ExportToExcel: 'Exporter vers Excel',
    SearchByName: 'Rechercher par nom',
    DataUpdatedAsOf: 'Données mises à jour : {datetime}',
    DrilldownLoadError: 'Échec du chargement des détails'
  },
    ccConsultantDetail: {
    ConsultantDetails: 'Détails du Consultant',
    LoadingDetails: 'Chargement des détails du consultant...',
    FullName: 'Nom Complet',
    Status: 'Statut',
    Address: 'Adresse',
    Phone: 'Téléphone',
    Email: 'E-mail',
    Sponsor: 'Sponsor',
    Recruiter: 'Recruteur',
    PersonalGroup: 'Groupe Personnel',
    ProfilePhotoAlt: 'Photo de profil',
    NoAddressAvailable: 'Aucune adresse disponible',
    NotAvailable: 'N/D',
    Retry: 'Réessayer',
    BusinessDetails: 'Détails de l\'Entreprise',
    ViewBusinessDetails: 'Voir les Détails de l\'Entreprise',
    SearchConsultant: 'Rechercher Consultant',
    SearchPlaceholder: 'Tapez pour rechercher des consultants...',
    AddBookmark: 'Ajouter un signet',
    RemoveBookmark: 'Supprimer le signet',
    Bookmark: 'Signet',
    BookmarkedConsultants: 'Consultants Enregistrés',
    NoBookmarkedConsultants: 'Aucun consultant enregistré pour le moment'
  },
  eventManagement: {
    AddGuest: 'Ajouter un Invité',
    AddGuestButton: 'Ajouter les Invités Sélectionnés',
    FindGuestError: 'Veuillez sélectionner au moins un invité à ajouter',
    DuplicateGuestError: 'Cet invité a déjà été ajouté à l\'événement',
    AddGuestCancelButton: 'Annuler',
    BreadCrumbPage: 'Fête',
    CreateOrder: 'Créer une Commande',
    DeleteButton: 'Supprimer',
    EmailAddress: 'Adresse E-mail',
    EventDate: 'Date',
    EventID: 'ID de l\'Événement',
    EventInfo: 'Informations sur l\'Événement',
    EventList: 'Accueil',
    EventEndTime: 'Heure de Fin',
    EventStartTime: 'Heure de Début',
    EventStatus: 'Statut de l\'Événement',
    EventTitle: 'Titre de l\'Événement',
    EventType: 'Type d\'Événement',
    EventWhen: 'Quand',
    EventWhere: 'Où',
    FindContact: 'Rechercher un Contact',
    FirstName: 'Prénom',
    GuestInfo: 'Informations sur les Invités',
    GuestName: 'Nom',
    GuestRole: 'Rôle',
    Guests: 'Invités',
    Hostess: 'Hôtesse',
    HostEmail: 'E-mail de l\'Hôte',
    HostName: 'Nom de l\'Hôte',
    HostPhoneNumber: 'Téléphone de l\'Hôte',
    InviteOpened: 'Invitation Ouverte',
    InviteVisited: 'Invitation Visitée',
    LastName: 'Nom de Famille',
    MakeHost: 'Faire Hôte',
    NewContact: 'Nouveau Contact',
    OrderTotal: 'Total / Dû',
    PhoneNumber: 'Numéro de Téléphone',
    PlaceOrder: 'Passer Commande',
    RSVP: 'RSVP',
    SaveButton: 'Enregistrer',
    SendEmail: 'Envoyer un E-mail',
    ViewReceipt: 'Voir le Reçu',
    TransferButton: 'Transférer l\'Événement',
    SendEmailTo: 'Envoyer un E-mail À',
    EmailSubject: 'Objet de l\'E-mail',
    EmailBody: 'Corps de l\'E-mail',
    Cancel: 'Annuler',
    Send: 'Envoyer',
    // Host Portal Messages
    HostPortalHeader: 'Portail de l\'hôte',
    HostPortalStep1: 'Étape 1 : Configurer le portail de l\'hôte',
    HostPortalStep2: 'Étape 2 : Créer un mot de passe',
    HostPortalStep3: 'Étape 3 : Envoyer l\'invitation',
    ChooseTheme: 'Choisissez le thème du portail de l\'hôte',
    ImagePreview: 'Aperçu de l\'image sur le thème :',
    PasswordPlaceholder: 'Entrez le mot de passe pour l\'hôte (ex., Cooking Show1)',
    OptionalNote: 'Note optionnelle :',
    CcMeOnEmails: 'Me mettre en copie de tous les e-mails concernant le portail de l\'hôte',
    SendEmailButton: 'Envoyer un e-mail',
    SavePortalSettings: 'Enregistrer les paramètres du portail',
    ViewHostDashboard: 'Voir le Tableau de Bord de l\'Hôte',
    HostPortalColumn: 'Portail de l\'hôte',
    ManageHostPortal: 'Gérer',
    ViewHostPortal: 'Voir',
    // Email Editor Messages
    EmailPreview: 'Aperçu de l\'e-mail',
    To: 'À',
    From: 'De',
    Regarding: 'Objet',
    SendInvitation: 'Envoyer l\'invitation',
    // Success Messages
    PortalSettingsSaved: 'Paramètres du portail enregistrés',
    InvitationEmailSent: 'E-mail d\'invitation envoyé',
    // Default Values
    NoEmailTemplate: 'Aucun modèle d\'e-mail disponible',
    // Error Messages
    CopyFailed: 'Échec de la copie dans le presse-papiers',
    // Validation Messages
    EventDatePastError: 'La date de l\'événement ne peut pas être dans le passé',
    EventEndTimeBeforeStartError: 'L\'heure de fin ne peut pas être avant l\'heure de début',
    InvalidEmailFormat: 'Veuillez entrer une adresse e-mail valide',
    MissingRequiredFields: 'Les champs obligatoires suivants sont manquants : {fields}',
    CannotCloseEventWithItemsTitle: 'Impossible de Fermer l\'Événement',
    CannotCloseEventWithItemsMessage: 'Cet événement ne peut pas être fermé car il y a des paniers non soumis avec des articles. Veuillez vous assurer que tous les paniers sont vides ou soumis avant de fermer l\'événement.',
    CannotDeleteEventWithItemsTitle: 'Impossible de Supprimer l\'Événement',
    CannotDeleteEventWithItemsMessage: 'Cet événement ne peut pas être supprimé car il y a des paniers non soumis avec des articles. Veuillez vous assurer que tous les paniers sont vides ou soumis avant de supprimer l\'événement.',
    // Cart URL Messages
    CartPageUrl: 'URL de la Page de Boutique',
    CartPageUrlUnavailable: 'L\'URL de la page boutique n\'est pas disponible tant que votre boutique publique est désactivée.',
    CopyCartUrl: 'Copier l\'URL',
    Copied: 'Copié !',
    // Email Messages
    EmailSubjectAndBodyRequired: 'Veuillez saisir à la fois l\'objet et le corps de l\'e-mail',
    GuestEmailNotAvailable: 'L\'adresse e-mail de l\'invité n\'est pas disponible',
    EmailSentSuccessfully: 'E-mail envoyé avec succès',
    EmailSendFailed: 'Échec de l\'envoi de l\'e-mail. Veuillez réessayer.',
    PleaseCompleteAllFields: 'Veuillez remplir tous les champs obligatoires',
  },
  gamificationDifferenceMessage: {
    OrderTotal_FreeShipping: 'Livraison gratuite lorsque vous dépensez plus de {totalAmount}',
    PartyOrderTotal_FreeShipping: 'Livraison gratuite lorsque vous dépensez plus de {totalAmount}',
    OrderTotal: 'Dépensez seulement {difference} de plus pour obtenir des réductions supplémentaires',
  },
  phoneInput: {
    placeholder: 'Entrer le numéro de téléphone',
    phoneNumber: 'Numéro de téléphone',
    extension: 'Poste',
    type: 'Type de téléphone',
    home: 'Domicile',
    cell: 'Mobile',
    work: 'Travail',
    other: 'Autre',
    required: 'Le numéro de téléphone est obligatoire',
    invalid: 'Veuillez entrer un numéro de téléphone valide',
    country: {
      DE: 'DE',
      AT: 'AT',
      FR: 'FR',
    }
  },
  marketing: {
    optInConfirm: {
      title: 'Confirmation par e-mail',
      confirmedMessage: 'Merci d\'avoir confirmé votre abonnement par e-mail.',
      noEmailProvided: 'Aucune adresse e-mail fournie.',
    },
  },
  hostPortalPage: {
    loadingEventDetails: 'Chargement des détails de l\'événement...',
    genericErrorTitle: 'Oups ! Une erreur est survenue',
    tryAgain: 'Réessayer',
    eventTitleFallback: "Événement de {name}",
    eventSubtitle: 'Événement Pampered Chef',
    eventImageAlt: 'Image de l\'événement {number}',
    descriptionTitle: 'Chouchoutez votre cuisine cet été !',
    hostedBy: 'Organisé par',
    location: 'Lieu',
    eventDescription: 'Bienvenue à mon événement Pampered Chef ! Rejoignez-nous pour un bon moment avec de super produits.',
    shopNow: 'Acheter maintenant',
    shareThisInvite: 'Partager cette invitation',
    shareText: 'SMS',
    shareFacebook: 'Facebook',
    shareEmail: 'E-mail',
    copy: 'Copier',
    starts: 'Commence',
    hostingQuestion: 'Organisez-vous la soirée ?',
    signInToSeeDashboard: 'Connectez-vous pour voir votre tableau de bord',
    inviteLinkCopiedTitle: 'Copié',
    inviteLinkCopiedMessage: 'Lien d\'invitation copié dans le presse-papiers',
    unknownHost: 'Hôte inconnu',
    errors: {
      noEventIdProvided: 'Aucun identifiant d\'événement fourni',
      eventNotFound: 'Événement introuvable',
      loadingEventDetails: 'Erreur lors du chargement des détails de l\'événement',
      copyInviteLinkFailed: 'Impossible de copier le lien d\'invitation',
      guestNotFound: 'Invité introuvable pour cet événement',
      loadingGuestDetails: 'Erreur lors du chargement des informations de l\'invité',
      updateStatusFailed: 'Impossible de mettre à jour votre RSVP. Veuillez réessayer.',
    },
    guestSection: {
      heading: 'Votre RSVP',
      greeting: 'Bonjour {name},',
      currentStatusLabel: 'Votre statut actuel :',
      changeStatusLabel: 'Mettre à jour votre RSVP :',
      statusUpdatedTitle: 'RSVP mis à jour',
      statusUpdatedMessage: 'Merci ! Votre RSVP a été enregistré.',
    },
  }
  ,
  kendo: {
    grid: {
      pagerItemsPerPage: 'éléments par page',
      pagerInfo: '{0} - {1} sur {2} éléments',
      noRecords: 'Aucun enregistrement disponible',
    },
  },
  countries: {
    germany: 'Allemagne',
    austria: 'Autriche',
    france: 'France',
    switzerland: 'Suisse',
    belgium: 'Belgique',
    spain: 'Espagne',
    italy: 'Italie',
    netherlands: 'Pays-Bas',
    poland: 'Pologne',
    unitedKingdom: 'Royaume-Uni',
    ireland: 'Irlande',
    portugal: 'Portugal',
    sweden: 'Suède',
    denmark: 'Danemark',
    norway: 'Norvège',
    finland: 'Finlande',
    unitedStates: 'États-Unis',
    canada: 'Canada',
    australia: 'Australie',
    newZealand: 'Nouvelle-Zélande',
    japan: 'Japon',
    china: 'Chine',
    brazil: 'Brésil',
    mexico: 'Mexique',
    india: 'Inde',
    unknown: 'Inconnu',
  },
  pagination: {
    previousPage: 'Page précédente',
    nextPage: 'Page suivante',
    goToPage: 'Aller à la page {page}',
    ellipsis: '...',
  },
  hostDashboard: {
    EventDetails: 'Détails de la fête',
    Welcome: 'Bienvenue, {firstName}!',
    WelcomeSubTitle: 'Dans le tableau de bord hôte, vous pouvez suivre le succès de votre fête et vos récompenses.',
    GuestActions: 'Actions invité',
    CurrentPartyTotal: 'Total actuel de la fête',
    CurrentPartyTotalDescription: 'Ventes totales pour votre fête actuelle',
    ProductSales: 'Ventes de produits',
    ProductSalesDescription: 'Ventes totales de produits hors taxes et frais de port',
    GuestList: 'Liste des invités de la fête',
    InvitationReminder: 'Envoyer une invitation',
    ChangeStatus: 'Changer le statut',
    RemoveGuest: 'Retirer l\'invité',
    EventRewards: 'Mes récompenses',
    AddGuest: "+ Invité",
    ImportGuests: 'Importer des invités',
    Import: 'Importer',
    AddGuestButton: 'Ajouter',
    AddGuestCancelButton: 'Annuler',
    Invited: 'Invités',
    Attending: 'Commandes',
    GuestName: 'Nom',
    EmailAddress: 'E-mail',
    GuestOrderTotal: 'Total de commande',
    CodeTextInvitationStatus: 'Statut',
    TotalSales: 'Ventes totales',
    OrderStatus: 'Statut de la commande',
    OrderSubmitted: 'Soumise',
    OrderPending: 'En attente',
    NoRewardsYet: 'Aucune récompense gagnée pour le moment.',
    RewardsGuide: 'Guide des récompenses',
    RewardsPdfUrl: 'https://ttgcommon-180003f.s3.eu-central-1.amazonaws.com/tpc/contentimages/032026_Nouveau_programme_hotesse_FR_RE280226-1.png',
    GuestSales: 'Ventes des invités',
    GuestSalesLeftToReach: 'de ventes des invités restant pour atteindre le prochain niveau de récompense',
    AllRewardsEarned: 'Vous avez atteint tous les niveaux de récompense !',
    AboutRewardLevels: 'À propos des niveaux de récompense',
    YourRewardsLevel: 'Votre niveau de récompense',
    ShopMyWishList: 'Acheter ma liste de souhaits',
    ShopAll: 'Tout acheter',
    EnterPassword: 'Entrez le mot de passe',
    PasswordRequired: 'Veuillez entrer le mot de passe pour accéder au tableau de bord hôte.',
    PasswordPlaceholder: 'Mot de passe',
    InvalidPassword: 'Mot de passe invalide. Veuillez réessayer.',
    HostPortalImage1: 'host-a-party-half-price-products.jpg',
    HostPortalImage2: 'de-cons-and-host.jpg',
    HostPortalImage3: 'boxes.jpg',
  },
  earnedDiscountToDescription: {
    Default: "{quantity} - {awardMessage}",
    DiscountedItem: "{awardDescription} ({awardMessage})",
    FreeProduct: "{awardDescription} ({awardMessage})",
    SelectFreeProduct: "{appliedAmount} - {awardMessage}",
  },
  myStory: {
    NoStoryAvailable: 'Aucune histoire disponible pour le moment.',
  }
}
